var _g, _path, _path2, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14, _path16, _g15, _path17, _g16, _path18, _g17, _path19, _g18, _path20, _g19, _path21, _g20, _path22, _g21, _path23, _g22, _path24, _g23, _path25, _g24, _path26, _g25, _path27, _g26, _path28, _g27, _path29, _g28, _path30, _g29, _path31, _g30, _path32, _g31, _path33, _g32, _path34, _g33, _path35, _g34, _path36, _g35, _path37, _g36, _path38, _g37, _path39, _g38, _path40, _g39, _path41, _g40, _path42, _g41, _path43, _g42, _path44, _g43, _path45, _g44, _path46, _g45, _path47, _g46, _path48, _g47, _path49, _g48, _path50, _g49, _path51, _g50, _path52, _g51, _path53, _g52, _path54, _g53, _path55, _g54, _path56, _g55, _path57, _g56, _path58, _g57, _path59, _g58, _path60, _g59, _path61, _g60, _path62, _g61, _path63, _g62, _path64, _g63, _path65, _g64, _path66, _g65, _path67, _g66, _path68, _g67, _path69, _g68, _path70, _g69, _path71, _g70, _path72, _g71, _path73, _g72, _path74, _g73, _path75, _g74, _path76, _g75, _path77, _g76, _path78, _g77, _path79, _g78, _path80, _g79, _path81, _g80, _path82, _g81, _path83, _g82, _path84, _g83, _path85, _g84, _path86, _g85, _path87, _g86, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _g87, _path95, _g88, _path96, _g89, _path97, _g90, _path98, _g91, _path99, _g92, _path100, _g93, _path101, _g94, _path102, _g95, _path103, _g96, _path104, _g97, _path105, _g98, _path106, _g99, _path107, _g100, _path108, _g101, _path109, _g102, _path110, _g103, _path111, _g104, _path112, _g105, _path113, _g106, _path114, _g107, _path115, _g108, _path116, _g109, _path117, _g110, _path118, _g111, _path119, _g112, _path120, _g113, _path121, _g114, _path122, _g115, _path123, _g116, _path124, _g117, _path125, _g118, _path126, _g119, _path127, _g120, _path128, _g121, _path129, _g122, _path130, _g123, _path131, _g124, _path132, _g125, _path133, _g126, _path134, _g127, _path135, _g128, _path136, _g129, _path137, _g130, _path138, _g131, _path139, _g132, _path140, _g133, _path141, _g134, _path142, _g135, _path143, _g136, _path144, _g137, _path145, _g138, _path146, _g139, _path147, _g140, _path148, _g141, _path149, _g142, _path150, _g143, _path151, _g144, _path152, _g145, _path153, _g146, _path154, _g147, _path155, _g148, _path156, _g149, _path157, _g150, _path158, _g151, _path159, _g152, _path160, _g153, _path161, _g154, _path162, _g155, _path163, _g156, _path164, _g157, _path165, _g158, _path166, _g159, _path167, _g160, _path168, _g161, _path169, _g162, _path170, _g163, _path171, _g164, _path172, _g165, _path173, _g166, _path174, _g167, _path175, _g168, _path176, _g169, _path177, _g170, _path178, _g171, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _g172, _path208, _path209, _g173, _path210, _path211, _g174, _path212, _path213, _g175, _path214, _path215, _g176, _path216, _path217, _g177, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnowManWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 97,
    viewBox: "0 0 100 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2395_11214)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.66,
    filter: "url(#filter0_f_2395_11214)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9384,
    cy: 54.9341,
    rx: 35.4774,
    ry: 41.7143,
    transform: "rotate(-16.9279 48.9384 54.9341)",
    fill: "#72B2DE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9748 59.9418C15.4105 59.6999 15.8959 59.82 16.3628 59.689C16.6241 59.6172 16.7551 59.678 16.9905 59.5502C17.1989 59.4329 17.4243 59.5404 17.6412 59.5223C17.8647 59.5043 18.0249 59.4154 18.2372 59.3645C18.4886 59.3024 18.6629 59.3431 18.8909 59.394C18.3383 58.8118 17.7849 58.2157 17.179 57.6962C16.9442 57.4952 16.73 57.2755 16.5173 57.0493C16.3973 56.9172 16.2723 56.79 16.1424 56.666C16.0896 56.614 15.7854 56.4379 15.907 56.4281C15.2389 56.4862 15.0373 55.4459 15.7151 55.3879C16.3473 55.3311 16.8106 55.8323 17.2188 56.2559C17.6287 56.6845 18.0819 57.0651 18.5008 57.4815C18.5659 57.1425 18.6677 56.8079 18.7383 56.5256C18.9202 55.7702 18.6577 54.8557 19.2457 54.2648C19.7257 53.7814 20.4176 54.5827 19.9409 55.0596C19.8296 55.1703 19.9118 55.5538 19.9144 55.6949C19.9213 55.9819 19.8531 56.2814 19.7989 56.5623C19.7429 56.8562 19.6642 57.1418 19.6204 57.4415C19.5802 57.6954 19.4138 58.0713 19.5481 58.2969C19.6217 58.4246 19.6302 58.5468 19.6044 58.6524C19.7319 58.7739 19.8626 58.8937 19.9893 59.016C20.0924 59.1177 20.1848 59.2233 20.2732 59.3297C20.2732 59.3297 20.2749 59.3314 20.2773 59.3322C20.5093 59.4135 20.6129 59.5979 20.6193 59.789C20.7287 59.9415 20.8348 60.0973 20.9516 60.2457C21.1502 60.5071 21.7322 60.5476 22.0277 60.6457C22.5699 60.8269 23.0813 60.9636 23.6494 61.0211C24.0373 61.0601 24.4979 61.0841 24.8468 61.2728C25.4064 61.5771 25.9361 61.4507 26.5417 61.5053C27.5132 61.5945 28.4599 61.937 29.3683 62.28C30.3711 62.6581 31.3501 63.0877 32.3381 63.5034C33.0265 63.7956 33.9644 63.928 34.4918 64.4945C34.9544 64.9948 34.1636 65.6907 33.7027 65.192C33.5007 64.9716 33.0957 64.912 32.8205 64.8246C32.4012 64.696 31.9985 64.5036 31.5973 64.3309C30.6818 63.9395 29.7695 63.5579 28.8415 63.205C27.9576 62.872 26.9913 62.5114 26.0389 62.5469C25.5569 62.567 25.1624 62.5444 24.709 62.3729C24.254 62.1998 23.8663 62.1034 23.3798 62.0546C22.5175 61.9678 21.7421 61.6103 20.9031 61.4236C20.3639 61.3064 20.0082 60.7978 19.6712 60.3198C19.428 60.354 19.1348 60.4707 18.9309 60.4725C18.7067 60.4716 18.603 60.3363 18.4051 60.4529C18.2531 60.5436 18.0061 60.5377 17.8364 60.5593C17.6806 60.577 17.424 60.5169 17.2875 60.5921C17.1044 60.6941 16.9337 60.7625 16.7185 60.7461C16.5359 60.7332 16.4224 60.766 16.2347 60.8089C15.9719 60.8659 15.6789 60.7588 15.4402 60.8898C14.8427 61.2207 14.3838 60.2678 14.9748 59.9418Z",
    fill: "#67472D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1676 37.7775C76.6886 37.9133 76.4273 38.3418 76.0036 38.5787C75.7675 38.7122 75.7169 38.8481 75.4601 38.9236C75.2299 38.9874 75.1447 39.2232 74.9777 39.3637C74.8062 39.5088 74.63 39.5588 74.4435 39.6726C74.2213 39.8061 74.1257 39.9582 73.999 40.1556C73.9852 39.3509 73.9622 38.5357 74.0301 37.738C74.0566 37.4291 74.0555 37.1214 74.0486 36.8102C74.0416 36.6313 74.0416 36.4525 74.0474 36.2725C74.0486 36.1982 74.1418 35.858 74.0486 35.9369C74.5644 35.5061 73.9806 34.6236 73.4579 35.0614C72.9686 35.4678 72.9893 36.1518 72.9951 36.7417C73.0031 37.3362 72.9467 37.9273 72.9398 38.5195C72.6566 38.3244 72.3503 38.1583 72.1027 38.0074C71.4453 37.5986 70.9928 36.7626 70.1616 36.7579C69.4822 36.7533 69.5502 37.8123 70.2226 37.8146C70.3792 37.8146 70.5887 38.1456 70.6854 38.2478C70.8812 38.4568 71.1391 38.6217 71.3739 38.7831C71.6192 38.9526 71.8748 39.1001 72.1154 39.2824C72.3215 39.4345 72.7026 39.5843 72.7648 39.8398C72.8016 39.9826 72.8811 40.0755 72.9732 40.1324C72.9674 40.3089 72.9582 40.4866 72.9536 40.6631C72.9513 40.8082 72.9594 40.9487 72.9709 41.0869C72.9709 41.0869 72.9709 41.0892 72.9697 41.0916C72.8615 41.3134 72.9168 41.5177 73.0457 41.6582C73.0745 41.844 73.1079 42.0298 73.1286 42.2179C73.1701 42.5442 72.7844 42.9843 72.6427 43.263C72.3837 43.7751 72.1154 44.2338 71.7516 44.6762C71.5029 44.9781 71.192 45.3207 71.0757 45.7016C70.8904 46.3135 70.4252 46.598 70.0326 47.0648C69.404 47.815 68.9699 48.7277 68.5635 49.6137C68.1144 50.5914 67.7184 51.5889 67.3062 52.5829C67.0206 53.2773 66.4461 54.0344 66.4668 54.8101C66.4875 55.4929 67.5364 55.4291 67.5157 54.7486C67.5054 54.449 67.7517 54.1204 67.8865 53.8637C68.0949 53.4759 68.2468 53.0544 68.4115 52.648C68.7891 51.7225 69.1714 50.8063 69.5847 49.8994C69.9808 49.0377 70.416 48.0983 71.1183 47.4504C71.4753 47.1241 71.7401 46.8291 71.9427 46.3867C72.1454 45.9419 72.3537 45.5994 72.6658 45.2208C73.2184 44.5497 73.5201 43.7473 73.9864 43.0215C74.288 42.557 74.1856 41.9439 74.0912 41.3656C74.288 41.2181 74.5782 41.0939 74.7244 40.9511C74.8833 40.792 74.8626 40.6224 75.0848 40.5655C75.2563 40.5226 75.4279 40.3437 75.5637 40.2392C75.6869 40.1417 75.8274 39.9176 75.9771 39.8746C76.1786 39.8177 76.3478 39.7457 76.4894 39.582C76.6103 39.4438 76.714 39.3869 76.8775 39.2847C77.1043 39.1396 77.2378 38.8562 77.4992 38.7808C78.1555 38.5938 77.8158 37.5917 77.1676 37.7775Z",
    fill: "#67472D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8884 26.8005L85.2156 32.6193L77.8446 100.004L25.5174 94.1822L32.8884 26.8005Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4055 92.4067C27.6002 85.4522 20.9753 62.6204 29.6059 41.4132C33.9212 30.8078 41.2335 22.6178 49.5682 17.9485L48.608 26.7296L85.4758 30.8322L86.2737 23.5293C89.1233 26.9793 91.258 31.1469 92.5959 35.7604L86.7446 35.1089L83.3861 65.8149L90.4601 66.6022C81.8271 87.8117 61.2097 99.3646 44.4055 92.4067Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4516 92.2906C27.6981 85.357 21.0927 62.5937 29.6968 41.4515C33.9995 30.8799 41.2888 22.713 49.5982 18.0566L48.6494 26.7343L85.409 30.823L86.1966 23.6199C89.037 27.0606 91.1647 31.2154 92.5014 35.815L86.74 35.1752L83.3918 65.7882L90.368 66.5639C81.7627 87.7073 61.2051 99.2288 44.4516 92.2906Z",
    fill: "#FEFEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4999 92.1744C27.7971 85.2594 21.2113 62.5682 29.7901 41.4898C34.0789 30.9483 41.3475 22.8082 49.6327 18.168L48.6955 26.7389L85.34 30.8171L86.1171 23.714C88.9495 27.1407 91.0703 31.2862 92.4013 35.8707L86.7331 35.2402L83.3953 65.7603L90.277 66.5267C81.6959 87.6074 61.2005 99.0895 44.4999 92.1744Z",
    fill: "#FDFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5471 92.0594C27.8949 85.1642 21.331 62.5414 29.8822 41.5258C34.1584 31.018 41.4039 22.9034 49.6626 18.2748L48.7358 26.7436L85.2709 30.8078L86.0377 23.8069C88.8597 27.2243 90.9759 31.3547 92.3011 35.9276L86.7239 35.3087L83.3953 65.7359L90.1826 66.4907C81.6326 87.5029 61.1982 98.9512 44.5471 92.0594Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5955 91.941C27.994 85.069 21.4473 62.5159 29.9732 41.5642C34.2367 31.09 41.4603 22.9987 49.6937 18.3852L48.7796 26.7471L85.2029 30.7997L85.9571 23.8963C88.771 27.3056 90.8803 31.4233 92.2032 35.9822L86.717 35.3726L83.3988 65.7069L90.0882 66.4513C81.5658 87.403 61.197 98.8131 44.5955 91.941Z",
    fill: "#FBFDFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6439 91.8261C28.093 84.9761 21.5671 62.4915 30.0653 41.6036C34.315 31.1597 41.5179 23.095 49.726 18.4955L48.8233 26.7552L85.1327 30.795L85.8765 23.9915C88.6835 27.3892 90.7848 31.4941 92.1019 36.0391L86.7089 35.4376L83.4034 65.6779L89.9995 66.4129C81.499 87.2985 61.1901 98.6772 44.6439 91.8261Z",
    fill: "#FAFCFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6899 91.71C28.1908 84.8809 21.6833 62.4637 30.1597 41.6397C34.3967 31.2294 41.5766 23.1868 49.7571 18.6035L48.8659 26.7587L85.0659 30.7846L85.7993 24.0833C88.596 27.4694 90.6903 31.5626 92.0052 36.0925L86.7032 35.5026L83.4057 65.6535L89.9063 66.3746C81.4334 87.1964 61.1878 98.5391 44.6899 91.71Z",
    fill: "#F9FBFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.736 91.5938C28.2887 84.7856 21.8031 62.4369 30.2506 41.6779C34.475 31.3025 41.633 23.2843 49.7893 18.715L48.9085 26.7645L84.998 30.7788L85.7211 24.1738C88.5085 27.5506 90.5971 31.6311 91.9073 36.1494L86.6974 35.5711L83.4103 65.6245L89.8142 66.3363C81.3666 87.0941 61.1855 98.4032 44.736 91.5938Z",
    fill: "#F8FBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7832 91.4765C28.3866 84.6881 21.9217 62.4102 30.3439 41.7186C34.5533 31.3698 41.6894 23.3772 49.8215 18.8206L48.9523 26.768L84.9289 30.7707L85.6393 24.2667C88.4187 27.6319 90.5027 31.7008 91.8095 36.2028L86.6882 35.6338L83.4114 65.5966L89.722 66.2968C81.2998 86.9919 61.1809 98.2661 44.7832 91.4765Z",
    fill: "#F7FAFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8315 91.3605C28.4856 84.5929 22.0391 62.3847 30.4349 41.7569C34.6339 31.443 41.747 23.4725 49.8538 18.9298L48.996 26.7726L84.8587 30.7614L85.5587 24.3585C88.3312 27.7132 90.4071 31.7705 91.7105 36.2586L86.6813 35.7L83.4149 65.5664L89.6288 66.2585C81.2342 86.8886 61.1763 98.1257 44.8315 91.3605Z",
    fill: "#F6FAFB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8799 91.2431C28.5835 84.5 22.1577 62.3603 30.5281 41.7941C34.7133 31.5115 41.8034 23.5688 49.886 19.0413L49.0397 26.7773L84.7919 30.7556L85.4816 24.4525C88.2437 27.798 90.3127 31.8367 91.6126 36.3143L86.6767 35.765L83.4195 65.542L89.5378 66.2225C81.1674 86.7864 61.174 97.9898 44.8799 91.2431Z",
    fill: "#F5F9FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9271 91.1294C28.6825 84.4048 22.2763 62.3325 30.6202 41.8324C34.7916 31.5812 41.8598 23.6641 49.9159 19.1505L49.0812 26.7819L84.7228 30.7486L85.401 24.5431C88.155 27.8793 90.2183 31.9099 91.5136 36.3689L86.6675 35.8289L83.4218 65.5119L89.4457 66.183C81.1018 86.6842 61.1717 97.854 44.9271 91.1294Z",
    fill: "#F4F9FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9731 91.0109C28.7804 84.3096 22.3949 62.3081 30.7112 41.8707C34.8711 31.6532 41.9174 23.7581 49.9482 19.2584L49.1238 26.7854L73.7215 29.5224L75.0917 17.0045C91.2856 23.7059 97.6688 45.7085 89.3525 66.1447C81.035 86.582 61.1648 97.7158 44.9731 91.0109Z",
    fill: "#F3F8FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0192 90.8959C28.8782 84.212 22.5135 62.2802 30.8045 41.9067C34.9505 31.7217 41.9738 23.8533 49.9793 19.3699L49.1676 26.7912L73.687 29.52L75.0433 17.1206C91.1866 23.8022 97.5536 45.7329 89.2615 66.1087C80.9682 86.4798 61.1625 97.5776 45.0192 90.8959Z",
    fill: "#F2F7FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0675 90.7775C28.9761 84.1168 22.6309 62.2558 30.8966 41.9462C35.0288 31.7926 42.0314 23.9497 50.0104 19.4767L49.2102 26.7982L73.6525 29.5177L74.9961 17.2356C91.0887 23.8986 97.4327 45.7596 89.1706 66.0704C80.9026 86.3754 61.1602 97.4394 45.0675 90.7775Z",
    fill: "#F1F7F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1159 90.6625C29.0751 84.0216 22.7507 62.2279 30.9875 41.9845C35.1071 31.8645 42.0878 24.0472 50.0437 19.5882L49.2539 26.8028L73.6191 29.5131L74.9501 17.354C90.9909 23.995 97.3153 45.7875 89.0761 66.032C80.8381 86.2755 61.1556 97.3023 45.1159 90.6625Z",
    fill: "#F0F6F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1631 90.5464C29.173 83.9287 22.8669 62.2012 31.0796 42.0228C35.1842 31.9342 42.1431 24.1402 50.0737 19.6962L49.2954 26.8063L73.5857 29.5073L74.9028 17.469C90.8918 24.0891 97.1956 45.8119 88.9852 65.9926C80.7714 86.171 61.151 97.1642 45.1631 90.5464Z",
    fill: "#EFF6F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2115 90.4303C29.272 83.8334 22.9867 62.1756 31.1729 42.0611C35.266 32.0027 42.2018 24.2342 50.1071 19.8053L49.3414 26.8109L73.5512 29.5049L74.8556 17.5851C90.794 24.1831 97.0793 45.8397 88.8919 65.9542C80.7057 86.0699 61.1498 97.0283 45.2115 90.4303Z",
    fill: "#EEF5F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2575 90.313C29.3687 83.7359 23.1064 62.1513 31.2627 42.0995C35.3443 32.0724 42.2582 24.3294 50.1382 19.9133L49.384 26.8144L73.5178 29.5003L74.8084 17.7012C90.695 24.2783 96.9607 45.8653 88.7987 65.9171C80.6389 85.9678 61.1463 96.8901 45.2575 90.313Z",
    fill: "#EDF4F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3036 90.1969C29.4666 83.6407 23.2227 62.1234 31.3583 42.1389C35.4237 32.1432 42.3158 24.4258 50.1704 20.0236L49.4266 26.8214L73.4821 29.498L74.7601 17.8185C90.5971 24.3747 96.8421 45.892 88.7089 65.8776C80.5745 85.8655 61.1417 96.7542 45.3036 90.1969Z",
    fill: "#ECF4F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3519 90.0796C29.5656 83.5455 23.3425 62.099 31.4492 42.1773C35.5032 32.2164 42.3734 24.521 50.2026 20.134L49.4704 26.8249L73.4475 29.4922L74.7117 17.9346C90.4981 24.4688 96.7235 45.9175 88.6156 65.8393C80.5089 85.7634 61.1383 96.6161 45.3519 90.0796Z",
    fill: "#EBF3F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3991 89.9635C29.6634 83.4526 23.4587 62.0724 31.5425 42.2133C35.5826 32.2838 42.4309 24.614 50.2326 20.2432L49.5118 26.8296L73.4153 29.4899L74.6657 18.0496C90.399 24.564 96.6026 45.9443 88.5235 65.8022C80.4421 85.6589 61.1348 96.4768 45.3991 89.9635Z",
    fill: "#E9F3F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4475 89.8474C29.7625 83.355 23.5785 62.0468 31.6346 42.2516C35.6609 32.3546 42.4873 24.7091 50.2671 20.3523L49.5579 26.8365L73.3819 29.4852L74.6196 18.1657C90.3012 24.6592 96.4875 45.9686 88.4325 65.7638C80.3764 85.559 61.1302 96.3385 45.4475 89.8474Z",
    fill: "#E8F2F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4947 89.7324C29.8603 83.2598 23.6971 62.0201 31.7255 42.2899C35.7415 32.4266 42.5438 24.8032 50.297 20.4603L49.5993 26.84L73.3462 29.4818L74.5724 18.2819C90.2045 24.7521 96.37 45.9919 88.3381 65.7232C80.3097 85.4545 61.1268 96.2027 45.4947 89.7324Z",
    fill: "#E7F2F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5419 89.614C29.9594 83.1646 23.8157 61.9922 31.8177 42.3271C35.8198 32.4951 42.6002 24.8996 50.3281 20.5729L49.6419 26.8458L73.3117 29.4794L74.5241 18.4026C90.1055 24.8531 96.2503 46.0244 88.2472 65.6883C80.244 85.3523 61.1233 96.0668 45.5419 89.614Z",
    fill: "#E6F1F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.588 89.499C30.0584 83.0694 23.9331 61.9678 31.9109 42.3654C35.8981 32.5648 42.6577 24.9948 50.3604 20.6786L49.6857 26.8504L73.276 29.4748L74.4745 18.5187C90.0064 24.9484 96.1305 46.0499 88.1527 65.65C80.1772 85.2501 61.121 95.9287 45.588 89.499Z",
    fill: "#E5F0F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6352 89.3829C30.1562 82.9741 24.0517 61.9399 32.0019 42.4037C35.9787 32.6379 42.7142 25.0923 50.3915 20.79L49.7283 26.8551L73.2426 29.4701L74.4285 18.6337C89.9086 25.0424 96.012 46.0731 88.0618 65.6094C80.1105 85.1491 61.1164 95.7904 45.6352 89.3829Z",
    fill: "#E4F0F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6835 89.2668C30.2553 82.8789 24.1691 61.9156 32.0951 42.4444C36.0558 32.7053 42.7706 25.1876 50.4237 20.8981L49.772 26.8586L73.2103 29.4667L74.3824 18.7487C89.8119 25.1376 95.8957 46.101 87.9731 65.5711C80.0448 85.0446 61.1118 95.6523 45.6835 89.2668Z",
    fill: "#E3EFF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7319 89.1495C30.352 82.7825 24.2889 61.89 32.1872 42.4803C36.1353 32.7761 42.8281 25.2804 50.4548 21.0072L49.8146 26.8632L73.1758 29.462L74.3341 18.8659C89.7128 25.2294 95.7759 46.1254 87.8764 65.5339C79.9781 84.9447 61.1095 95.5152 45.7319 89.1495Z",
    fill: "#E2EFF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7791 89.0334C30.451 82.6873 24.4063 61.8633 32.2793 42.5198C36.2159 32.8493 42.8857 25.3757 50.4859 21.1187L49.8572 26.8679L73.1413 29.4574L74.2869 18.9821C89.615 25.3281 95.6585 46.1533 87.7843 65.4968C79.9124 84.8402 61.1049 95.3794 45.7791 89.0334Z",
    fill: "#E1EEF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8251 88.9161C30.5488 82.5921 24.5261 61.8377 32.3715 42.5581C36.2941 32.9166 42.9421 25.4709 50.5193 21.2255L49.9021 26.8725L73.1067 29.4562L74.2385 19.0981C89.5171 25.4233 95.5387 46.1776 87.6945 65.4584C79.8468 84.738 61.1014 95.2412 45.8251 88.9161Z",
    fill: "#E0EDF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8712 88.8C30.6479 82.4969 24.6424 61.8111 32.4624 42.5941C36.3736 32.9863 42.9974 25.5661 50.5492 21.3335L49.9436 26.8783L73.0722 29.4504L74.1913 19.2155C89.4181 25.5162 95.4202 46.2044 87.6001 65.4213C79.7823 84.6359 61.0992 95.103 45.8712 88.8Z",
    fill: "#DFEDF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9196 88.685C30.7457 82.404 24.7621 61.7855 32.5557 42.6324C36.4542 33.0571 43.0573 25.6613 50.5837 21.4449L49.9885 26.8841L73.0376 29.4469L74.1441 19.3315C89.3214 25.6114 95.3027 46.2299 87.5091 65.3829C79.7156 84.5313 61.0968 94.9671 45.9196 88.685Z",
    fill: "#DEECF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9679 88.5689C30.8436 82.3065 24.8818 61.7588 32.6489 42.6719C36.5325 33.1279 43.1137 25.7577 50.6148 21.5541L50.0311 26.8887L73.0042 29.4446L74.098 19.4477C89.2224 25.7078 95.1853 46.2578 87.417 65.3446C79.6488 84.4315 61.0922 94.829 45.9679 88.5689Z",
    fill: "#DDECF1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0151 88.4505C30.9415 82.2113 25.0004 61.7321 32.7399 42.7103C36.6108 33.2 43.1701 25.8518 50.6471 21.6656L50.0748 26.8934L72.972 29.44L74.0531 19.5627C89.1245 25.8042 95.0678 46.2845 87.3249 65.304C79.582 84.3282 61.0876 94.692 46.0151 88.4505Z",
    fill: "#DCEBF1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0635 88.3355C31.0405 82.116 25.1179 61.7065 32.8343 42.7486C36.6914 33.2684 43.2265 25.947 50.677 21.7713L50.1163 26.8969L72.9363 29.4341L74.0036 19.6799C89.0255 25.8994 94.9469 46.3089 87.2328 65.2668C79.5187 84.2283 61.0853 94.5538 46.0635 88.3355Z",
    fill: "#DBEBF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1095 88.2171C31.1383 82.0208 25.2341 61.6799 32.9253 42.7869C36.7697 33.3381 43.2852 26.0422 50.7104 21.8805L50.16 26.9015L72.9006 29.433L73.9541 19.7961C88.9253 25.9946 94.8272 46.3333 87.1395 65.2285C79.4519 84.1238 61.0807 94.4156 46.1095 88.2171Z",
    fill: "#DAEAF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1556 88.1021C31.2374 81.9256 25.3539 61.6543 33.0174 42.8252C36.848 33.4113 43.3416 26.1374 50.7415 21.9919L50.2038 26.9062L72.8661 29.4283L73.9069 19.9122C88.8263 26.0898 94.7109 46.3611 87.0463 65.1902C79.3851 84.0216 61.0761 94.2774 46.1556 88.1021Z",
    fill: "#D9E9F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2039 87.986C31.3341 81.8304 25.4725 61.6299 33.1095 42.8624C36.9286 33.4798 43.3981 26.2315 50.7726 22.1011L50.2464 26.912L72.8315 29.4249L73.8597 20.0283C88.7296 26.1862 94.5946 46.3867 86.9565 65.1542C79.3195 83.9194 61.0738 94.1416 46.2039 87.986Z",
    fill: "#D8E9EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2512 87.8698C31.4319 81.7351 25.5922 61.602 33.2004 42.9007C37.0057 33.5494 43.4533 26.3267 50.8025 22.2102L50.2878 26.9166L72.7993 29.4225L73.8137 20.1467C88.6317 26.2814 94.4749 46.4145 86.8644 65.117C79.2527 83.8172 61.0715 94.0033 46.2512 87.8698Z",
    fill: "#D7E8EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2995 87.7526C31.531 81.6399 25.7085 61.5777 33.2937 42.939C37.0851 33.6203 43.512 26.4208 50.8359 22.3205L50.3327 26.9224L72.7647 29.4167L73.7664 20.2629C88.5327 26.3755 94.3551 46.4389 86.7699 65.0764C79.1871 83.7127 61.0657 93.8664 46.2995 87.7526Z",
    fill: "#D6E8EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3479 87.6364C31.63 81.5447 25.8271 61.5498 33.3858 42.9773C37.1634 33.6899 43.5696 26.516 50.867 22.4273L50.3753 26.927L72.7302 29.4132L73.7181 20.3801C88.4325 26.4718 94.2354 46.4644 86.6802 65.0392C79.1203 83.6105 61.0623 93.7304 46.3479 87.6364Z",
    fill: "#D5E7EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3939 87.5192C31.7278 81.4495 25.9457 61.5231 33.4768 43.0134C37.244 33.762 43.626 26.6112 50.8992 22.5377L50.4179 26.9306L72.6957 29.4098L73.672 20.4916C88.3358 26.5625 94.1203 46.4924 86.5869 64.9986C79.0547 83.5083 61.06 93.59 46.3939 87.5192Z",
    fill: "#D5E7EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7186 86.7226C32.4014 80.7969 26.7574 61.3466 34.11 43.277C41.4638 25.2097 59.0313 15.3672 73.3462 21.2929C87.6611 27.2185 93.3074 46.6689 85.9536 64.7385C78.6033 82.8058 61.0358 92.6494 46.7186 86.7226Z",
    fill: "#D9E9F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0444 85.9248C33.0749 80.1431 27.5691 61.1654 34.7421 43.5405C41.9151 25.911 59.0543 16.3078 73.0204 22.0918C86.9876 27.8734 92.4957 46.8488 85.3227 64.476C78.1474 82.1032 61.0105 91.7076 47.0444 85.9248Z",
    fill: "#DCEBF1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3691 85.1259C33.7508 79.4905 28.3808 60.9878 35.3742 43.8006C42.3699 26.6135 59.0785 17.2518 72.698 22.8895C86.314 28.5249 91.6851 47.0277 84.6894 64.2148C77.6972 81.4019 60.9851 90.7647 47.3691 85.1259Z",
    fill: "#E0EDF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6915 84.3304C34.4243 78.8367 29.1937 60.8089 36.0075 44.0619C42.8212 27.3172 59.1038 18.1959 72.3721 23.6884C85.6405 29.1821 90.8746 47.2076 84.0573 63.9546C77.2424 80.6993 60.961 89.823 47.6915 84.3304Z",
    fill: "#E3EFF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0185 83.5315C35.0967 78.1842 30.0054 60.6289 36.6396 44.3244C43.2749 28.0175 59.1292 19.1342 72.0475 24.4839C84.9669 29.8336 90.0606 47.3865 83.4264 63.6911C76.7899 79.9956 60.938 88.8789 48.0185 83.5315Z",
    fill: "#E5F0F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3409 82.7338C35.7726 77.5292 30.8137 60.4501 37.2694 44.5856C43.7274 28.7234 59.1522 20.0794 71.7216 25.2828C84.2934 30.4873 89.25 47.5653 82.792 63.4298C76.3374 79.2954 60.9115 87.936 48.3409 82.7338Z",
    fill: "#E8F2F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6667 81.9349C36.4473 76.8755 31.6265 60.2713 37.9038 44.8492C44.181 29.4225 59.1764 21.0212 71.3981 26.0794C83.6198 31.1388 88.4383 47.7453 82.161 63.1685C75.8838 78.5918 60.8884 86.9943 48.6667 81.9349Z",
    fill: "#EAF3F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9914 81.1371C37.1197 76.2241 32.4382 60.0925 38.537 45.1105C44.6346 30.1274 59.1994 21.9629 71.0734 26.8772C82.9474 31.7914 87.6266 47.9241 81.5301 62.9061C75.4313 77.8892 60.8631 86.0514 48.9914 81.1371Z",
    fill: "#EDF4F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3161 80.3382C37.7932 75.5691 33.2488 59.9148 39.1668 45.3706C45.086 30.8287 59.2259 22.9058 70.7487 27.676C82.2716 32.4451 86.8149 48.1018 80.8969 62.646C74.9777 77.1855 60.8401 85.1073 49.3161 80.3382Z",
    fill: "#EFF6F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6408 79.5405C38.4668 74.9165 34.0605 59.7336 39.8001 45.6342C45.5408 31.5313 59.2501 23.8499 70.4252 28.4761C81.5969 33.0978 86.002 48.2806 80.2636 62.3824C74.5275 76.4853 60.8159 84.1667 49.6408 79.5405Z",
    fill: "#F0F7F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9655 78.7438C39.1415 74.2627 34.8734 59.5571 40.4345 45.8943C45.9921 32.2315 59.2742 24.7904 70.0994 29.2739C80.9245 33.7503 85.1914 48.4582 79.6338 62.1211C74.0716 75.7816 60.7906 83.2249 49.9655 78.7438Z",
    fill: "#F2F8FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2913 77.9449C39.8139 73.609 35.6851 59.3771 41.0654 46.1567C46.4469 32.934 59.2984 25.7333 69.7758 30.0705C80.2498 34.4041 84.3797 48.6382 79.0005 61.8587C73.6202 75.0814 60.7652 82.2821 50.2913 77.9449Z",
    fill: "#F4F9FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6148 77.1472C40.4874 72.9564 36.4956 59.1984 41.6964 46.418C46.8982 33.6377 59.3237 26.6751 69.4488 30.8671C79.5751 35.0602 83.5692 48.8183 78.3685 61.5986C73.1677 74.3777 60.7411 81.3404 50.6148 77.1472Z",
    fill: "#F5F9FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.9395 76.3506C41.161 72.3026 37.3074 59.0183 42.3296 46.6781C47.3495 34.3402 59.3479 27.618 69.1241 31.6636C78.8992 35.7116 82.7551 48.9959 77.7352 61.3361C72.7129 73.6752 60.718 80.3974 50.9395 76.3506Z",
    fill: "#F6FAFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2653 75.5505C41.8368 71.65 38.1202 58.8395 42.9629 46.9417C47.8043 35.0416 59.3733 28.562 68.8006 32.4625C78.228 36.3654 81.9469 49.1747 77.1031 61.0737C72.2616 72.9714 60.6939 79.4533 51.2653 75.5505Z",
    fill: "#F8FBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.59 74.7516C42.5104 70.9962 38.9319 58.6607 43.5938 47.2018C48.2568 35.7453 59.3963 29.5038 68.4759 33.2615C77.5544 37.0215 81.1352 49.3547 76.471 60.8136C71.8068 72.2724 60.6685 78.5128 51.59 74.7516Z",
    fill: "#F9FBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9147 73.9562C43.1839 70.3413 39.7436 58.4819 44.2271 47.4654C48.7105 36.4479 59.4205 30.4467 68.1501 34.0604C76.8809 37.6753 80.3235 49.5347 75.8389 60.55C71.3566 71.5676 60.6432 77.571 51.9147 73.9562Z",
    fill: "#FAFCFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2371 73.1573C43.8598 69.6876 40.5565 58.3019 44.858 47.7267C49.1606 37.1515 59.4458 31.3884 67.8254 34.8581C76.2062 38.3278 79.5106 49.7135 75.2057 60.2887C70.9018 70.865 60.6202 76.6258 52.2371 73.1573Z",
    fill: "#FAFCFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5641 72.3595C44.5322 69.035 41.3659 58.1231 45.4901 47.988C49.6166 37.8541 59.4711 32.3325 67.5019 35.6571C75.5338 38.9816 78.7 49.8935 74.5736 60.0286C70.4505 70.1614 60.5948 75.6841 52.5641 72.3595Z",
    fill: "#FBFDFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8876 71.5606C45.2069 68.3835 42.1776 57.9431 46.1245 48.2504C50.0691 38.5543 59.4941 33.2731 67.176 36.4525C74.8602 39.6319 77.8883 50.07 73.9426 59.765C69.9946 69.4611 60.5707 74.7435 52.8876 71.5606Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2146 70.7652C45.8804 67.7286 42.9893 57.7654 46.7554 48.5117C50.5216 39.258 59.5195 34.216 66.8525 37.2514C74.1844 40.2857 77.0755 50.2512 73.3094 59.5049C69.5444 68.7574 60.5442 73.7994 53.2146 70.7652Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5381 69.9663C46.554 67.0772 43.7988 57.5877 47.3864 48.7718C50.9741 39.9582 59.5437 35.1589 66.5267 38.0492C73.5097 40.9383 76.2626 50.4277 72.6761 59.2436C69.0908 68.0572 60.5212 72.8588 53.5381 69.9663Z",
    fill: "#FDFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8617 69.1685C47.2264 66.4222 44.6105 57.4089 48.0196 49.0354C51.4277 40.6619 59.5667 36.0983 66.202 38.8481C72.8373 41.5944 75.452 50.6077 72.0463 58.9812C68.6371 67.3535 60.497 71.9148 53.8617 69.1685Z",
    fill: "#FDFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1875 68.3696C47.9022 65.7685 45.4245 57.2266 48.6518 49.2955C51.8802 41.3644 59.5932 37.0435 65.8773 39.6435C72.1615 42.2469 74.6392 50.7865 71.4131 58.7199C68.1846 66.651 60.474 70.9719 54.1875 68.3696Z",
    fill: "#FEFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.511 67.5718C48.5758 65.1158 46.2362 57.0512 49.2839 49.5591C52.3327 42.0681 59.6173 37.9853 65.5526 40.4412C71.4879 42.8995 73.8298 50.9653 70.7798 58.4563C67.731 65.9473 60.4475 70.0301 54.511 67.5718Z",
    fill: "#FEFEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8369 66.7729C49.2493 64.4621 47.0467 56.8713 49.9171 49.8192C52.7874 42.7672 59.6404 38.9259 65.2302 41.2413C70.8155 43.5522 73.0192 51.143 70.15 58.1927C67.2808 65.2471 60.4233 69.0895 54.8369 66.7729Z",
    fill: "#FEFEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1604 65.9775C49.9228 63.8095 47.8584 56.6924 50.548 50.0816C53.2376 43.4732 59.6657 39.8711 64.9021 42.0391C70.1408 44.207 72.2063 51.3241 69.5168 57.9349C66.8249 64.5434 60.3991 68.1431 55.1604 65.9775Z",
    fill: "#FEFFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4874 65.1786C50.5987 63.1534 48.6713 56.5125 51.1813 50.3441C53.6936 44.1722 59.6922 40.814 64.5809 42.8369C69.4684 44.862 71.3981 51.503 68.8835 57.6713C66.3735 63.8432 60.3761 67.2026 55.4874 65.1786Z",
    fill: "#FEFFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8109 64.3808C51.2734 62.5008 49.483 56.3336 51.8134 50.6053C54.1437 44.8782 59.714 41.7557 64.2539 43.6357C68.7937 45.5157 70.5841 51.6829 68.2526 57.4112C65.9211 63.1383 60.3496 66.2608 55.8109 64.3808Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1356 63.5819C51.9458 61.8471 50.2947 56.156 52.4455 50.8678C54.5974 45.5785 59.7382 42.6987 63.9303 44.4335C68.1213 46.1661 69.7724 51.8583 67.6205 57.1477C65.4674 62.437 60.3243 65.3168 56.1356 63.5819Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4603 62.7865C52.6194 61.1968 51.1042 55.9759 53.0764 51.129C55.051 46.2821 59.7624 43.6427 63.6057 45.2301C67.4478 46.8198 68.9607 52.0383 66.9872 56.8875C65.0138 61.7344 60.3013 64.3738 56.4603 62.7865Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.785 61.9876C53.2929 60.543 51.9159 55.796 53.7097 51.3892C55.5035 46.9824 59.7866 44.5833 63.2787 46.0279C66.7708 47.4724 68.1478 52.2195 66.3551 56.6263C64.5613 61.0331 60.2771 63.4321 56.785 61.9876Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1108 61.1898C53.9664 59.8904 52.7276 55.6195 54.3441 51.6528C55.9571 47.6861 59.8142 45.525 62.9563 46.8268C66.0984 48.1262 67.3372 52.3971 65.723 56.3638C64.11 60.3305 60.2529 62.4892 57.1108 61.1898Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4332 60.3909C54.6411 59.2343 53.5404 55.4395 54.9727 51.9129C56.4085 48.3886 59.8372 46.4668 62.6293 47.6245C65.4237 48.7811 66.5244 52.5759 65.0898 56.1002C63.654 59.6268 60.2287 61.5474 57.4332 60.3909Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.7602 59.5932C55.3147 58.5817 54.3498 55.2595 55.6071 52.1765C56.8633 49.0923 59.8603 47.4097 62.3058 48.4234C64.7478 49.4349 65.7127 52.7559 64.4577 55.8401C63.2038 58.9243 60.2022 60.6069 57.7602 59.5932Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0837 58.7942C55.9882 57.928 55.1616 55.0818 56.2392 52.4366C57.3135 49.7925 59.8844 48.3526 61.9776 49.2212C64.0731 50.0875 64.8998 52.9336 63.8256 55.5788C62.7479 58.2229 60.1792 59.6628 58.0837 58.7942Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4084 57.9988C56.6618 57.2753 55.9744 54.903 56.8702 52.6978C57.7671 50.4962 59.9121 49.2955 61.6564 50.0166C63.4019 50.74 64.0892 53.1124 63.1935 55.3175C62.2977 57.5204 60.155 58.7199 58.4084 57.9988Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7331 57.1999C57.3365 56.6216 56.7861 54.723 57.5034 52.9614C58.2219 51.1976 59.9351 50.2372 61.3317 50.8155C62.7283 51.3938 63.2787 53.2901 62.5614 55.054C61.8441 56.8167 60.1297 57.7782 58.7331 57.1999Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0589 56.4021C58.0112 55.969 57.5978 54.5442 58.1355 53.225C58.6732 51.9001 59.9581 51.1813 61.0059 51.6144C62.0536 52.0476 62.467 53.4724 61.9304 54.7915C61.3904 56.1165 60.1055 56.8353 59.0589 56.4021Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3825 55.6032C58.6836 55.3129 58.4084 54.3653 58.7688 53.4828C59.1257 52.6026 59.9823 52.1242 60.6812 52.4122C61.3801 52.7025 61.6553 53.65 61.296 54.5302C60.938 55.4128 60.0813 55.8912 59.3825 55.6032Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 30,
    width: 48,
    height: 64
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1448 48.9065C58.687 46.0011 59.7636 42.0391 58.6606 38.2315C56.8955 32.1258 50.198 28.7258 43.7055 30.636C37.2106 32.5485 33.3766 39.0455 35.1416 45.1535C36.1491 48.6301 38.7592 51.2312 42.0176 52.4726C33.0565 57.8211 28.3543 68.2523 31.2178 78.1516C34.6512 90.0309 47.6823 96.6474 60.3151 92.9304C72.9501 89.2134 80.4075 76.5689 76.9707 64.6897C74.2926 55.4197 65.7645 49.3524 56.1448 48.9065Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7071 54.8055C59.3594 54.6603 59.2213 54.1889 59.3997 53.7464C59.5782 53.3063 60.0076 53.066 60.3565 53.2088C60.7077 53.3563 60.8458 53.8277 60.6651 54.2702C60.4843 54.7103 60.056 54.9506 59.7071 54.8055Z",
    fill: "white"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M58.968 61.4476C59.3744 61.2572 59.5033 60.6905 59.2362 60.1645C58.9691 59.6385 58.4314 59.4097 58.0434 59.6315C57.6531 59.8556 57.5621 60.4072 57.8143 60.9019C58.0641 61.3919 58.5604 61.6392 58.968 61.4476ZM58.7665 60.4362C58.7642 60.4269 58.7619 60.4176 58.7584 60.4107C58.7527 60.3991 58.7457 60.3921 58.7388 60.3793C58.7515 60.3863 58.7619 60.3909 58.7665 60.3956C58.7699 60.4049 58.7688 60.4211 58.7665 60.4362ZM58.2806 60.629C58.2864 60.6383 58.2875 60.6452 58.2921 60.6511C58.2979 60.6627 58.3048 60.672 58.3105 60.6824C58.2967 60.6754 58.2864 60.6708 58.2841 60.6661C58.2806 60.6592 58.2783 60.6452 58.2806 60.629Z",
    fill: "#67472D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3266 64.814C60.8101 64.6711 61.0439 64.0545 60.8274 63.4194C60.6098 62.7842 60.0468 62.4416 59.5793 62.6297C59.1119 62.8178 58.93 63.4194 59.1303 64.0093C59.3318 64.6003 59.843 64.9568 60.3266 64.814Z",
    fill: "#67472D"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5442 65.7523C60.0572 65.8754 59.7969 66.4444 59.9167 67.0517C60.0399 67.659 60.4993 68.0793 60.9967 68.0015C61.4941 67.9249 61.8084 67.3466 61.6783 66.6929C61.5447 66.0414 61.0335 65.6303 60.5442 65.7523Z",
    fill: "#67472D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1533 69.2347C60.6536 69.2893 60.3139 69.8107 60.3485 70.4296C60.3818 71.0485 60.7791 71.5293 61.2811 71.5246C61.7854 71.52 62.178 70.994 62.1411 70.3297C62.1031 69.6632 61.6552 69.1848 61.1533 69.2347Z",
    fill: "#67472D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M60.718 76.0128C61.212 76.101 61.6932 75.6539 61.7796 74.9944C61.8625 74.3348 61.5079 73.7832 61.0059 73.7426C60.5062 73.7043 60.0756 74.1502 59.9984 74.7633C59.9201 75.3764 60.2218 75.9222 60.718 76.0128Z",
    fill: "#67472D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4728 77.5235C59.9812 77.405 59.4895 77.7871 59.3145 78.3897C59.1395 78.9912 59.3479 79.5869 59.8234 79.7507C60.3001 79.9167 60.8481 79.544 61.037 78.8983C61.2235 78.2515 60.9587 77.6442 60.4728 77.5235Z",
    fill: "#67472D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 27,
    width: 24,
    height: 27
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4488 27.94C50.7251 26.5609 57.0638 31.1284 58.6052 38.1389C60.1512 45.151 56.3158 51.9503 50.0417 53.3308C43.7678 54.7102 37.4312 50.1452 35.8851 43.1342C34.3413 36.1235 38.1772 29.3197 44.4488 27.94Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3932 25.4652L31.4442 52.595L60.0997 55.8059L63.0487 28.676L34.3932 25.4652Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9467 53.2425C35.8244 50.365 33.1325 40.2787 36.9309 30.7196C40.7315 21.1593 49.5878 15.7434 56.7078 18.6221C63.8302 21.5019 66.5232 31.5882 62.7226 41.1473C58.9231 50.7064 50.0679 56.1246 42.9467 53.2425Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9767 53.1682C35.8877 50.2988 33.2062 40.2613 36.9884 30.7417C40.773 21.2232 49.5878 15.8317 56.6768 18.6987C63.768 21.5658 66.4484 31.6056 62.665 41.1229C58.8828 50.6414 50.0679 56.034 42.9767 53.1682Z",
    fill: "#FEFEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0078 53.088C35.9499 50.2349 33.281 40.2404 37.046 30.7637C40.8121 21.2905 49.589 15.9222 56.6468 18.7777C63.7047 21.6308 66.3735 31.6253 62.6063 41.0997C58.8425 50.5752 50.0679 55.9434 43.0078 53.088Z",
    fill: "#FDFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0389 53.0137C36.0121 50.1722 33.357 40.2194 37.1059 30.7869C40.8536 21.3567 49.589 16.0128 56.6169 18.8555C63.6425 21.6946 66.2999 31.6474 62.5499 41.0776C58.7999 50.5101 50.0656 55.8528 43.0389 53.0137Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0688 52.9336C36.0754 50.1048 33.4284 40.2009 37.1611 30.8113C40.8962 21.4229 49.5901 16.1045 56.5847 18.9321C63.5792 21.7608 66.2239 31.6648 62.4935 41.0544C58.7607 50.4439 50.0645 55.7623 43.0688 52.9336Z",
    fill: "#FBFDFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.101 52.8569C36.1387 50.0421 33.5056 40.1811 37.2199 30.8368C40.9342 21.4879 49.5901 16.1928 56.5547 19.0099C63.5182 21.827 66.1502 31.6834 62.4359 41.03C58.7193 50.3777 50.0622 55.6717 43.101 52.8569Z",
    fill: "#FAFCFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.131 52.7803C36.1997 49.9771 33.5792 40.1637 37.2786 30.8601C40.9756 21.5541 49.5913 16.2834 56.5248 19.0865C63.4537 21.8897 66.0753 31.7031 62.3772 41.0068C58.679 50.3104 50.0622 55.5811 43.131 52.7803Z",
    fill: "#F9FBFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1609 52.7025C36.2608 49.9133 33.6529 40.1428 37.3361 30.8798C41.0159 21.6203 49.5936 16.374 56.4925 19.1632C63.3915 21.9524 66.0017 31.7206 62.3207 40.9836C58.6387 50.2466 50.061 55.4929 43.1609 52.7025Z",
    fill: "#F8FBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1931 52.6259C36.3252 49.8471 33.7278 40.1243 37.3937 30.9054C41.0562 21.6854 49.5947 16.4646 56.4615 19.241C63.3293 22.0175 65.9268 31.7426 62.2632 40.9615C58.5984 50.178 50.0599 55.4012 43.1931 52.6259Z",
    fill: "#F7FAFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2231 52.5481C36.3874 49.7832 33.8015 40.1034 37.4501 30.9298C41.0977 21.7539 49.5947 16.5551 56.4315 19.3176C63.2683 22.0825 65.852 31.7624 62.2033 40.9359C58.5581 50.113 50.0599 55.3106 43.2231 52.5481Z",
    fill: "#F6FAFB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2542 52.4691C36.4507 49.7182 33.8786 40.0859 37.5089 30.9507C41.138 21.8177 49.5993 16.6445 56.4004 19.3978C63.205 22.1464 65.7783 31.781 62.1469 40.9139C58.5155 50.0468 50.0587 55.22 43.2542 52.4691Z",
    fill: "#F5F9FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2852 52.3948C36.5118 49.6555 33.9511 40.0662 37.5653 30.9739C41.1794 21.8851 49.5982 16.7374 56.3693 19.4721C63.1417 22.2114 65.7011 31.7983 62.0893 40.8906C58.4763 49.9806 50.0576 55.1317 43.2852 52.3948Z",
    fill: "#F4F9FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3163 52.317C36.5751 49.5904 34.0271 40.0476 37.6228 30.9983C41.2197 21.9512 49.5993 16.8257 56.3406 19.5487C63.0795 22.2752 65.6286 31.8181 62.0306 40.8674C58.4349 49.9156 50.0553 55.0412 43.3163 52.317Z",
    fill: "#F3F8FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3463 52.238C36.6396 49.5277 34.102 40.0267 37.6804 31.0227C41.26 22.0163 49.6005 16.9139 56.3072 19.6288C63.0173 22.3391 65.5526 31.8401 61.973 40.8442C58.3946 49.8494 50.0553 54.9506 43.3463 52.238Z",
    fill: "#F2F7FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3774 52.1626C36.6994 49.4616 34.1756 40.0081 37.738 31.0447C41.3003 22.0802 49.6005 17.0068 56.2772 19.7055C62.954 22.4042 65.4789 31.8599 61.9166 40.821C58.3543 49.7844 50.0518 54.8624 43.3774 52.1626Z",
    fill: "#F1F7F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4084 52.0836C36.7605 49.3965 34.2493 39.9884 37.7955 31.0656C41.3406 22.151 49.6016 17.0951 56.2485 19.7833C62.8918 22.4703 65.4052 31.8785 61.859 40.7989C58.3128 49.7182 50.0518 54.7706 43.4084 52.0836Z",
    fill: "#F0F6F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4384 52.007C36.8261 49.3327 34.3253 39.9687 37.8531 31.0912C41.3832 22.2137 49.6016 17.1857 56.2162 19.86C62.8285 22.5342 65.3281 31.8959 61.8015 40.7757C58.2737 49.652 50.0507 54.6801 43.4384 52.007Z",
    fill: "#EFF6F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4695 51.9292C36.8883 49.2688 34.4002 39.9501 37.9107 31.1156C41.4235 22.2799 49.6051 17.2763 56.1851 19.9366C62.7686 22.5969 65.2556 31.9157 61.7439 40.7502C58.2311 49.5847 50.0507 54.5895 43.4695 51.9292Z",
    fill: "#EEF5F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5005 51.8525C36.9504 49.2038 34.4727 39.9292 37.9671 31.1388C41.4638 22.3461 49.6051 17.3657 56.1563 20.0167C62.7053 22.6608 65.1807 31.9377 61.6875 40.7281C58.1908 49.5208 50.0495 54.5012 43.5005 51.8525Z",
    fill: "#EDF4F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5305 51.7747C37.0115 49.1387 34.5487 39.9106 38.0281 31.1608C41.5029 22.4134 49.6074 17.4562 56.1241 20.091C62.6408 22.7269 65.107 31.9574 61.6288 40.7048C58.1517 49.4523 50.0484 54.4106 43.5305 51.7747Z",
    fill: "#ECF4F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5616 51.698C37.0748 49.0737 34.6224 39.8908 38.0845 31.184C41.5444 22.4773 49.6085 17.5468 56.093 20.1688C62.5798 22.7908 65.0322 31.976 61.5724 40.6828C58.1091 49.3895 50.0484 54.32 43.5616 51.698Z",
    fill: "#EBF3F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5927 51.6191C37.1381 49.011 34.6972 39.8711 38.1421 31.2096C41.5858 22.5446 49.6085 17.635 56.0642 20.2478C62.5176 22.8559 64.9585 31.9934 61.5148 40.6572C58.0711 49.3211 50.0461 54.2318 43.5927 51.6191Z",
    fill: "#E9F3F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6226 51.5436C37.2003 48.9471 34.7732 39.8525 38.1997 31.2317C41.625 22.6108 49.6097 17.7256 56.032 20.3221C62.4543 22.9186 64.8825 32.0132 61.4549 40.634C58.0285 49.2549 50.0449 54.1401 43.6226 51.5436Z",
    fill: "#E8F2F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6537 51.4646C37.2636 48.8809 34.8469 39.8316 38.2572 31.2549C41.6676 22.677 49.6108 17.8162 56.0009 20.3999C62.391 22.9859 64.8065 32.0352 61.3985 40.6119C57.987 49.1898 50.0438 54.0495 43.6537 51.4646Z",
    fill: "#E7F2F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6859 51.3868C37.3269 48.8147 34.9229 39.813 38.3148 31.2769C41.7067 22.742 49.612 17.9044 55.9721 20.4788C62.3288 23.0486 64.734 32.055 61.3409 40.5887C57.9479 49.1236 50.0415 53.9589 43.6859 51.3868Z",
    fill: "#E6F1F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7147 51.3102C37.3891 48.7521 34.9954 39.7933 38.3712 31.3025C41.747 22.8083 49.612 17.9974 55.9399 20.5567C62.2655 23.1148 64.658 32.0712 61.2822 40.5644C57.9076 49.0586 50.0403 53.8684 43.7147 51.3102Z",
    fill: "#E5F0F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7435 51.2336C37.4513 48.6894 35.0714 39.7736 38.4288 31.3246C41.7896 22.8745 49.6143 18.0868 55.9088 20.6333C62.2056 23.1775 64.5855 32.091 61.2246 40.5423C57.8673 48.9925 50.0403 53.7778 43.7435 51.2336Z",
    fill: "#E4F0F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.778 51.1558C37.5146 48.6243 35.1463 39.755 38.4864 31.3443C41.8276 22.9395 49.6154 18.1762 55.8789 20.7076C62.14 23.2414 64.5095 32.1107 61.1671 40.5167C57.8247 48.9239 50.0391 53.6872 43.778 51.1558Z",
    fill: "#E3EFF4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8068 51.0791C37.5756 48.5593 35.2199 39.7341 38.5451 31.3698C41.8702 23.008 49.6177 18.2679 55.8478 20.7877C62.0778 23.3052 64.4347 32.1304 61.1095 40.497C57.7867 48.8612 50.038 53.5989 43.8068 51.0791Z",
    fill: "#E2EFF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8356 51.0013C37.6378 48.4931 35.2936 39.7155 38.6015 31.3943C41.9094 23.0707 49.6177 18.3573 55.8155 20.8644C62.0156 23.3703 64.3598 32.1502 61.0519 40.4715C57.7441 48.7927 50.038 53.5084 43.8356 51.0013Z",
    fill: "#E1EEF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8701 50.9247C37.7011 48.4304 35.3685 39.6958 38.6602 31.4198C41.9508 23.1369 49.6189 18.449 55.7879 20.9422C61.9558 23.4365 64.2861 32.1688 60.9967 40.4494C57.7038 48.7265 50.0368 53.4166 43.8701 50.9247Z",
    fill: "#E0EDF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8989 50.8481C37.7633 48.3666 35.4444 39.6784 38.7189 31.4407C41.9911 23.2031 49.62 18.5408 55.7557 21.0188C61.8913 23.5003 64.2124 32.1885 60.938 40.4239C57.6635 48.6615 50.0345 53.3261 43.8989 50.8481Z",
    fill: "#DFEDF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9277 50.7679C37.8243 48.3027 35.5158 39.6574 38.7753 31.4627C42.0303 23.2704 49.62 18.6279 55.7234 21.0954C61.8268 23.5653 64.1353 32.2059 60.8804 40.4029C57.6209 48.5953 50.0334 53.2378 43.9277 50.7679Z",
    fill: "#DEECF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9623 50.6936C37.89 48.2376 35.593 39.6389 38.8329 31.4883C42.074 23.3354 49.6212 18.7196 55.6935 21.1756C61.7646 23.6292 64.0616 32.228 60.8228 40.3786C57.5829 48.5291 50.0311 53.1472 43.9623 50.6936Z",
    fill: "#DDECF1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.991 50.6135C37.9521 48.1703 35.6667 39.6203 38.8893 31.5127C42.112 23.4028 49.6212 18.809 55.6624 21.2499C61.7036 23.6954 63.9868 32.2478 60.7641 40.3553C57.5414 48.4641 50.0311 53.0567 43.991 50.6135Z",
    fill: "#DCEBF1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0221 50.5368C38.0143 48.1076 35.7427 39.6005 38.9481 31.5336C42.1546 23.469 49.6247 18.8985 55.6325 21.3277C61.6414 23.7593 63.9131 32.2663 60.7077 40.331C57.5011 48.3979 50.0299 52.9684 44.0221 50.5368Z",
    fill: "#DBEBF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0544 50.4602C38.0753 48.0449 35.8163 39.5808 39.0056 31.5568C42.1949 23.5352 49.6258 18.9902 55.6025 21.4078C61.577 23.8231 63.8382 32.2849 60.6501 40.3112C57.4597 48.3329 50.0288 52.8778 44.0544 50.4602Z",
    fill: "#DAEAF0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.0831 50.3824C38.1387 47.981 35.89 39.5623 39.0632 31.5812C42.2352 23.6002 49.6258 19.0796 55.5715 21.4845C61.516 23.8859 63.7623 32.3047 60.5903 40.2857C57.4194 48.2667 50.0288 52.7861 44.0831 50.3824Z",
    fill: "#D9E9F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1142 50.3057C38.202 47.9148 35.9672 39.5413 39.1196 31.6056C42.2766 23.6675 49.6281 19.1678 55.5404 21.5588C61.4561 23.952 63.6909 32.3255 60.5338 40.2636C57.3791 48.2005 50.0276 52.6955 44.1142 50.3057Z",
    fill: "#D8E9EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask125_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1442 50.228C38.2641 47.8487 36.0386 39.5228 39.1772 31.6254C42.3158 23.7303 49.6293 19.2608 55.5104 21.6366C61.3904 24.0159 63.6137 32.3442 60.4763 40.2369C57.3376 48.1355 50.0276 52.6073 44.1442 50.228Z",
    fill: "#D7E8EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1752 50.1513C38.3252 47.7859 36.1145 39.503 39.2359 31.6486C42.3572 23.7976 49.6304 19.3502 55.4793 21.7156C61.3283 24.0809 63.54 32.3639 60.4187 40.216C57.2996 48.067 50.0242 52.5167 44.1752 50.1513Z",
    fill: "#D6E8EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask127_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2063 50.0747C38.3885 47.7233 36.1894 39.4833 39.2935 31.6741C42.3975 23.865 49.6304 19.4408 55.4471 21.7922C61.2661 24.1437 63.4652 32.3813 60.3611 40.1928C57.257 48.0031 50.0242 52.4262 44.2063 50.0747Z",
    fill: "#D5E7EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask128_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2374 49.9969C38.453 47.6582 36.2631 39.4647 39.351 31.6985C42.439 23.93 49.6316 19.5301 55.4172 21.8688C61.2039 24.2098 63.3915 32.401 60.3036 40.1695C57.2167 47.9357 50.023 52.3379 44.2374 49.9969Z",
    fill: "#D5E7EE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask129_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3698 49.6613C38.7224 47.3772 36.5855 39.3811 39.6009 31.7961C42.614 24.2168 49.6362 19.9215 55.2848 22.2044C60.9322 24.4886 63.068 32.4847 60.0549 40.0674C57.0417 47.6501 50.0196 51.9454 44.3698 49.6613Z",
    fill: "#D9E9F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask130_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask130_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5034 49.328C38.9918 47.0985 36.9078 39.2963 39.8496 31.8982C42.7913 24.5024 49.6396 20.3105 55.1501 22.5377C60.6605 24.7672 62.7433 32.5717 59.8039 39.9652C56.8656 47.3644 50.015 51.5552 44.5034 49.328Z",
    fill: "#DCEBF1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask131_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask131_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 48.9924C39.2647 46.8198 37.2314 39.2104 40.0994 32.0004C42.9652 24.7881 49.6454 20.7018 55.0188 22.8744C60.3899 25.0471 62.4221 32.6542 59.554 39.8665C56.6883 47.0776 50.0092 51.1651 44.6381 48.9924Z",
    fill: "#E0EDF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask132_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask132_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7694 48.6568C39.5353 46.5411 37.5549 39.1268 40.3493 32.1003C43.1425 25.0738 49.65 21.092 54.8841 23.21C60.1205 25.3257 62.0997 32.7378 59.3053 39.7666C56.5121 46.7919 50.0046 50.7749 44.7694 48.6568Z",
    fill: "#E3EFF3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask133_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask133_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9029 48.3213C39.8047 46.2625 37.8773 39.0455 40.5991 32.2002C43.3163 25.3595 49.6546 21.4833 54.7528 23.5433C59.8499 25.6045 61.7773 32.8214 59.0555 39.6644C56.336 46.5063 50 50.3824 44.9029 48.3213Z",
    fill: "#E5F0F5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask134_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask134_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0353 47.988C40.0741 45.9825 38.202 38.9595 40.8455 32.3023C43.4925 25.6462 49.6592 21.8746 54.6181 23.8789C59.5771 25.8831 61.4538 32.9073 58.8056 39.5645C56.161 46.2229 49.9965 49.9922 45.0353 47.988Z",
    fill: "#E8F2F6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask135_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask135_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1677 47.6524C40.3481 45.7016 38.5267 38.8771 41.0965 32.4045C43.6698 25.9319 49.6627 22.2648 54.4857 24.2145C59.3088 26.163 61.1314 32.9921 58.5581 39.4624C55.9848 45.935 49.9896 49.6021 45.1677 47.6524Z",
    fill: "#EAF3F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask136_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask136_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3036 47.3168C40.6198 45.4229 38.8479 38.7912 41.3463 32.502C43.8471 26.2176 49.6696 22.6538 54.3545 24.5477C59.0382 26.444 60.809 33.0757 58.3094 39.3625C55.8098 45.6493 49.9873 49.2096 45.3036 47.3168Z",
    fill: "#EDF4F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask137_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask137_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4348 46.9824C40.8893 45.143 39.1703 38.7064 41.595 32.6031C44.021 26.5021 49.673 23.044 54.2186 24.881C58.7653 26.7204 60.4843 33.157 58.0584 39.2603C55.6336 45.3636 49.9804 48.8217 45.4348 46.9824Z",
    fill: "#EFF6F8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask138_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask138_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5672 46.6468C41.1587 44.8643 39.4927 38.6228 41.8449 32.7052C44.1983 26.7877 49.6799 23.4364 54.0873 25.2189C58.4948 26.999 60.1619 33.2429 57.8085 39.1604C55.4563 45.078 49.977 48.4304 45.5672 46.6468Z",
    fill: "#F0F7F9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask139_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask139_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.702 46.3135C41.4315 44.588 39.8162 38.5392 42.0947 32.8052C44.3721 27.0734 49.6822 23.8267 53.9538 25.5522C58.2242 27.2801 59.8372 33.3265 57.5599 39.0606C55.2802 44.7923 49.9712 48.0403 45.702 46.3135Z",
    fill: "#F2F8FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask140_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask140_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8332 45.9779C41.7021 44.3081 40.1386 38.4545 42.3446 32.9073C44.5494 27.3602 49.688 24.2168 53.8202 25.8878C57.9548 27.5588 59.5149 33.4113 57.31 38.9584C55.1051 44.5067 49.9678 47.6501 45.8332 45.9779Z",
    fill: "#F4F9FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask141_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask141_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9691 45.6447C41.9727 44.0271 40.461 38.3708 42.5933 33.0072C44.7245 27.6459 49.6914 24.607 53.6878 26.2211C57.6819 27.8375 59.1913 33.4949 57.0602 38.8562C54.929 44.221 49.9632 47.2599 45.9691 45.6447Z",
    fill: "#F5F9FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask142_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask142_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1003 45.3091C42.2421 43.7484 40.7856 38.2872 42.842 33.1094C44.9018 27.9316 49.696 24.9972 53.5531 26.5567C57.4113 28.1173 58.8701 33.5785 56.8126 38.7564C54.7551 43.9342 49.9585 46.8698 46.1003 45.3091Z",
    fill: "#F6FAFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask143_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask143_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2327 44.9735C42.5138 43.4697 41.1069 38.2036 43.093 33.2092C45.0779 28.2149 49.7018 25.3873 53.4219 26.8934C57.1408 28.3972 58.5477 33.6633 56.5628 38.6576C54.5778 43.6485 49.9528 46.4772 46.2327 44.9735Z",
    fill: "#F8FBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask144_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask144_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3674 44.6402C42.7867 43.191 41.4327 38.12 43.3417 33.3114C45.2529 28.5005 49.7064 25.7798 53.2883 27.2267C56.8713 28.6759 58.2253 33.7492 56.3141 38.5555C54.4017 43.3629 49.9482 46.0871 46.3674 44.6402Z",
    fill: "#F9FBFC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask145_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask145_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4987 44.3046C43.0561 42.9123 41.7551 38.0364 43.5915 33.4113C45.4291 28.7862 49.711 26.17 53.1547 27.5623C56.5996 28.9546 57.903 33.8305 56.0642 38.4556C54.2255 43.0772 49.9447 45.6969 46.4987 44.3046Z",
    fill: "#FAFCFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask146_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask146_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6346 43.9691C43.3255 42.6337 42.0775 37.9493 43.8402 33.5112C45.6041 29.073 49.7133 26.5602 53.0223 27.8979C56.3267 29.2333 57.5794 33.9153 55.8144 38.3558C54.0505 42.7939 49.939 45.3068 46.6346 43.9691Z",
    fill: "#FAFCFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask147_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask147_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7658 43.6334C43.5973 42.3526 42.3998 37.868 44.0901 33.6133C45.7814 29.3587 49.7214 26.9503 52.8888 28.2334C56.0562 29.5119 57.2536 33.9989 55.5634 38.2512C53.8732 42.5059 49.9355 44.9143 46.7658 43.6334Z",
    fill: "#FBFDFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask148_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask148_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8994 43.3002C43.869 42.0751 42.7222 37.7821 44.3399 33.7155C45.9576 29.6466 49.7248 27.3405 52.7552 28.5644C55.7868 29.7918 56.9324 34.0848 55.3147 38.1514C53.6993 42.2203 49.9286 44.5241 46.8994 43.3002Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask149_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask149_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0329 42.9657C44.1396 41.7952 43.0446 37.6996 44.5897 33.8142C46.1349 29.9311 49.7306 27.7318 52.6217 28.9023C55.515 30.0705 56.6077 34.1684 55.0649 38.0515C53.522 41.9346 49.9252 44.1339 47.0329 42.9657Z",
    fill: "#FCFDFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask150_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask150_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1642 42.6302C44.409 41.5166 43.367 37.6137 44.8396 33.9141C46.3087 30.2168 49.734 28.122 52.4893 29.2356C55.2445 30.3492 56.2853 34.252 54.8173 37.9493C53.3459 41.6489 49.9194 43.7438 47.1642 42.6302Z",
    fill: "#FDFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask151_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask151_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2989 42.2945C44.6819 41.2378 43.6894 37.5289 45.0883 34.0162C46.4837 30.5036 49.7375 28.5144 52.3557 29.5711C54.9716 30.6301 55.9618 34.3344 54.5675 37.8494C53.1697 41.3632 49.9171 43.3536 47.2989 42.2945Z",
    fill: "#FDFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask152_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask152_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4302 41.9613C44.9524 40.9592 44.0141 37.4453 45.3381 34.1185C46.661 30.7893 49.7432 28.9023 52.2244 29.9044C54.7045 30.9089 55.6405 34.4204 54.3188 37.7496C52.9935 41.0764 49.9113 42.9622 47.4302 41.9613Z",
    fill: "#FEFEFE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask153_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask153_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5649 41.6257C45.223 40.6781 44.3376 37.3617 45.588 34.2183C46.8361 31.0749 49.7479 29.2924 52.0909 30.24C54.4339 31.1875 55.3193 34.504 54.0701 37.6474C52.8185 40.7908 49.9067 42.5721 47.5649 41.6257Z",
    fill: "#FEFEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask154_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask154_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6984 41.2901C45.4924 40.3983 44.6611 37.2781 45.8378 34.3205C47.0145 31.3606 49.7524 29.685 51.9573 30.5756C54.161 31.4663 54.9969 34.5876 53.8202 37.5452C52.6435 40.5051 49.9021 42.1819 47.6984 41.2901Z",
    fill: "#FEFEFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask155_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask155_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8297 40.9545C45.7641 40.1196 44.9835 37.1945 46.0865 34.4204C47.1895 31.6463 49.7571 30.0751 51.8226 30.9101C53.8905 31.7473 54.6734 34.6724 53.5704 37.4465C52.4674 40.2195 49.8975 41.7918 47.8297 40.9545Z",
    fill: "#FEFFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask156_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask156_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9644 40.6213C46.0347 39.8409 45.3059 37.1109 46.3364 34.5203C47.3645 31.9319 49.7628 30.4676 51.6902 31.2456C53.6199 32.026 54.3498 34.7571 53.3194 37.3467C52.2901 39.9338 49.8941 41.4016 47.9644 40.6213Z",
    fill: "#FEFFFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask157_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask157_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0968 40.2857C46.3064 39.5622 45.6294 37.0261 46.5862 34.6224C47.5395 32.2187 49.7663 30.8555 51.559 31.5789C53.3493 32.3047 54.0263 34.8407 53.0718 37.2445C52.1139 39.6482 49.8872 41.0114 48.0968 40.2857Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask158_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask158_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2304 39.9501C46.5758 39.2835 45.953 36.9402 46.8337 34.7223C47.7157 32.5044 49.772 31.248 51.4242 31.9168C53.0776 32.5833 53.7028 34.9244 52.8208 37.1446C51.9377 39.3625 49.8837 40.6189 48.2304 39.9501Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask159_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask159_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3639 39.6168C46.8487 39.0049 46.2753 36.8589 47.0836 34.8245C47.8919 32.7901 49.7755 31.6358 51.2918 32.2501C52.8059 32.8621 53.3781 35.008 52.571 37.0424C51.7627 39.0769 49.8768 40.2288 48.3639 39.6168Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask160_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask160_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4952 39.2836C47.1193 38.725 46.5977 36.773 47.3323 34.9244C48.068 33.0757 49.7812 32.0283 51.1571 32.5857C52.5353 33.1407 53.0546 35.0916 52.3212 36.9402C51.5877 38.7912 49.8757 39.8386 48.4952 39.2836Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask161_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask161_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6299 38.9468C47.3887 38.4451 46.919 36.6905 47.5821 35.0254C48.2442 33.3602 49.7847 32.4173 51.0259 32.9177C52.2647 33.4194 52.7322 35.174 52.0713 36.8392C51.4116 38.5055 49.8687 39.4461 48.6299 38.9468Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask162_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask162_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7623 38.6112C47.6593 38.1664 47.2448 36.6046 47.832 35.1252C48.4203 33.647 49.7893 32.8098 50.8923 33.2545C51.993 33.6992 52.4098 35.2611 51.8226 36.7405C51.2343 38.2198 49.8653 39.0582 48.7623 38.6112Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask163_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask163_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8958 38.2756C47.931 37.8878 47.5672 36.5222 48.0818 35.2251C48.5965 33.9327 49.7939 33.2 50.7588 33.5878C51.7236 33.9803 52.0874 35.3459 51.5739 36.6383C51.0581 37.9331 49.8607 38.6658 48.8958 38.2756Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask164_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask164_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0294 37.9423C48.2027 37.609 47.8907 36.4362 48.3305 35.3273C48.7715 34.2183 49.7997 33.5878 50.6275 33.9234C51.4542 34.2589 51.765 35.4271 51.3241 36.5384C50.8819 37.6474 49.8549 38.2756 49.0294 37.9423Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask165_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask165_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1607 37.6067C48.4721 37.328 48.2131 36.3526 48.5804 35.4271C48.9465 34.504 49.8031 33.9802 50.4916 34.2589C51.1813 34.5376 51.4427 35.5107 51.0731 36.4362C50.7069 37.3617 49.8503 37.8854 49.1607 37.6067Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask166_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask166_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2965 37.2711C48.7439 37.0494 48.5366 36.269 48.8291 35.5293C49.125 34.7896 49.81 34.3704 50.3615 34.5922C50.9107 34.8163 51.1203 35.5967 50.8244 36.3364C50.5308 37.0761 49.8457 37.4953 49.2965 37.2711Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask167_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask167_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4278 36.9379C49.0156 36.7695 48.859 36.1854 49.0778 35.6292C49.3 35.0741 49.8135 34.7629 50.2268 34.929C50.639 35.0962 50.7956 35.6815 50.5757 36.2353C50.3558 36.7904 49.8411 37.1039 49.4278 36.9379Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask168_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask168_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5613 36.6023C49.2873 36.4908 49.1814 36.1007 49.3276 35.7314C49.475 35.3598 49.8169 35.1508 50.0933 35.2623C50.3696 35.3761 50.4732 35.7662 50.3258 36.1355C50.1796 36.5048 49.8354 36.7138 49.5613 36.6023Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask169_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 28,
    width: 27,
    height: 25
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4631 36.4618C61.5217 42.5942 57.7187 49.4325 50.9717 51.7341C44.2236 54.0402 37.0875 50.9375 35.0277 44.8074C32.969 38.6774 36.7697 31.8413 43.5167 29.5352C50.2637 27.2313 57.4044 30.3341 59.4631 36.4618Z",
    fill: "white"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask169_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6949 36.269C49.5567 36.2121 49.5038 36.0171 49.5774 35.8336C49.6511 35.6455 49.8238 35.5433 49.962 35.6002C50.0979 35.6548 50.1497 35.8498 50.0771 36.0356C50.0035 36.2191 49.833 36.3236 49.6949 36.269Z",
    fill: "white"
  }))), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3915 36.6766C50.3915 36.6766 53.9204 36.4908 56.4937 33.1221C56.4937 33.1221 56.0193 39.0548 52.8646 40.3588C51.1652 41.0613 48.0553 40.4192 50.3915 36.6766Z",
    fill: "#F37D22"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0698 35.6977C47.3093 36.4095 47.0364 37.1446 46.4619 37.342C45.8873 37.5371 45.2287 37.1202 44.9893 36.4095C44.7509 35.6977 45.0238 34.965 45.5983 34.7676C46.1729 34.5702 46.8314 34.987 47.0698 35.6977Z",
    fill: "#67472D"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1363 33.8154C53.3562 34.4703 53.1432 35.1334 52.6608 35.2982C52.1784 35.462 51.6084 35.0648 51.3897 34.4111C51.1721 33.7585 51.3839 33.0931 51.8675 32.9282C52.3453 32.7645 52.9152 33.1616 53.1363 33.8154Z",
    fill: "#67472D"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6603 38.5113C49.6603 38.5113 52.7932 39.8177 54.8012 37.6044C54.8012 37.6044 56.4557 35.851 56.4937 33.1233C56.4937 33.1233 55.7522 39.7712 52.5952 40.3971C52.5952 40.3971 49.2228 41.5491 49.6603 38.5113Z",
    fill: "#C16128"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7503 35.4005L46.0761 35.1241C46.1936 35.2692 46.2995 35.4237 46.3905 35.5862L46.0197 35.7976C45.9437 35.6571 45.8539 35.5224 45.7503 35.4005Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9423 33.3857C51.9366 33.3718 51.9308 33.359 51.9285 33.3497H51.932L52.3384 33.2278C52.3419 33.2394 52.3419 33.2464 52.3453 33.2498C52.3799 33.3544 52.4328 33.4473 52.5042 33.5378L52.1738 33.8061C52.0713 33.6807 51.993 33.5401 51.9423 33.3857Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7411 43.558C45.7779 43.6799 45.7077 43.8123 45.5834 43.8483C45.4602 43.8843 45.3301 43.8123 45.2932 43.6869C45.2564 43.5626 45.3277 43.4325 45.4544 43.3965C45.5753 43.3582 45.7031 43.4314 45.7411 43.558Z",
    fill: "#69483B"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4549 44.2047C46.4918 44.329 46.4204 44.4614 46.296 44.495C46.1728 44.531 46.045 44.4614 46.0071 44.336C45.9702 44.2105 46.0427 44.0793 46.1648 44.0433C46.288 44.0073 46.4192 44.0793 46.4549 44.2047Z",
    fill: "#69483B"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6213 44.8829C47.6593 45.0071 47.5867 45.1372 47.4624 45.1732C47.3392 45.2115 47.2114 45.1395 47.1734 45.0118C47.1389 44.8875 47.2091 44.7575 47.3334 44.7215C47.4566 44.6855 47.5867 44.7575 47.6213 44.8829Z",
    fill: "#69483B"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7634 45.323C48.8003 45.4472 48.73 45.5796 48.6034 45.6133C48.4825 45.6516 48.3524 45.5796 48.3144 45.4542C48.281 45.33 48.3489 45.1976 48.4744 45.1616C48.5988 45.1279 48.7277 45.1976 48.7634 45.323Z",
    fill: "#69483B"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1577 45.525C50.1934 45.6493 50.1232 45.7794 49.9988 45.8177C49.8756 45.8513 49.7455 45.7817 49.7098 45.6563C49.6753 45.532 49.7444 45.3996 49.8699 45.3636C49.9919 45.3276 50.122 45.3996 50.1577 45.525Z",
    fill: "#69483B"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5048 45.4159C51.5405 45.5378 51.4703 45.6702 51.3459 45.7062C51.2216 45.7422 51.0903 45.6725 51.0558 45.5448C51.0178 45.4206 51.0903 45.2905 51.2135 45.2545C51.3379 45.2185 51.4668 45.2882 51.5048 45.4159Z",
    fill: "#69483B"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0914 45.028C53.1271 45.1523 53.0569 45.2847 52.9325 45.3207C52.8093 45.3567 52.6792 45.287 52.6435 45.1616C52.609 45.035 52.6792 44.905 52.8036 44.869C52.9279 44.833 53.0569 44.9026 53.0914 45.028Z",
    fill: "#69483B"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4581 44.4219C54.4938 44.5484 54.4212 44.6785 54.2957 44.7145C54.1725 44.7505 54.0436 44.6785 54.0067 44.5531C53.971 44.4288 54.0413 44.2988 54.1656 44.2605C54.29 44.2245 54.4212 44.2976 54.4581 44.4219Z",
    fill: "#69483B"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5576 43.6079C55.5933 43.7322 55.5231 43.8645 55.3964 43.9005C55.2755 43.9365 55.1454 43.8669 55.1097 43.7414C55.0741 43.6149 55.1443 43.4848 55.2663 43.4488C55.393 43.4128 55.5219 43.4837 55.5576 43.6079Z",
    fill: "#69483B"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6111 42.7695C56.6445 42.8937 56.5743 43.0238 56.4499 43.0598C56.3244 43.0958 56.1966 43.0261 56.1609 42.9007C56.1264 42.7765 56.1955 42.6441 56.3198 42.6081C56.4442 42.5721 56.5731 42.6441 56.6111 42.7695Z",
    fill: "#69483B"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1472 50.6089C39.1472 50.6089 38.2261 52.972 39.5134 55.9458C39.5134 55.9458 53.9457 56.7285 57.9225 50.5299C57.9225 50.5299 58.5788 46.1463 56.1886 47.1299C53.8052 48.11 43.732 53.1705 39.1472 50.6089Z",
    fill: "url(#paint0_linear_2395_11214)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2025 49.7066C52.2025 49.7066 59.0704 57.0118 56.6687 66.9065C56.6687 66.9065 60.0076 68.5693 62.9851 66.233C62.9851 66.233 61.1521 52.0128 54.2324 48.9309L52.2025 49.7066Z",
    fill: "#DF1A22"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0275 48.3643C54.0275 48.3643 54.3936 54.2295 61.1176 56.5206C67.8392 58.8094 70.7361 63.1976 68.9204 67.1434C68.9204 67.1434 74.9938 64.6236 76.1981 63.1744C76.1981 63.1744 73.2069 57.5471 68.2146 56.0166C60.9149 53.7755 56.6756 53.4376 57.1983 47.0672C57.1995 47.0672 54.5594 46.6224 54.0275 48.3643Z",
    fill: "#ED1C24"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0446 35.995C43.1171 35.9671 43.0734 35.9044 43.1275 35.8708C43.131 35.8638 43.0941 35.8615 43.1056 35.8522C43.1655 35.8231 43.1586 35.7523 43.1402 35.6884L43.1298 35.6908C43.1275 35.6792 43.1586 35.6745 43.1597 35.6641L43.1425 35.6617C43.1597 35.6641 43.1574 35.6455 43.1724 35.6432L43.1459 35.6269L43.1678 35.6246C43.2231 35.6223 43.1793 35.5863 43.2116 35.5677H43.1966C43.238 35.5398 43.2484 35.4945 43.2737 35.4585L43.2438 35.4492C43.2645 35.4539 43.2749 35.4446 43.2829 35.433C43.2634 35.4214 43.3094 35.4237 43.3002 35.4074H43.2956C43.3209 35.4051 43.2887 35.3865 43.3175 35.3912L43.3025 35.3772C43.3347 35.3842 43.291 35.3587 43.3094 35.3563H43.3152L43.3186 35.3401L43.3152 35.3378C43.3278 35.3238 43.3152 35.3087 43.3394 35.3192C43.3209 35.3052 43.3232 35.3285 43.3014 35.3099C43.344 35.2716 43.3474 35.21 43.3843 35.1671L43.3681 35.1485L43.3969 35.1346L43.3877 35.1229C43.3854 35.1067 43.4188 35.1229 43.413 35.1113L43.3889 35.102L43.4269 35.0835L43.4119 35.0811C43.4372 35.0811 43.4188 35.0602 43.4384 35.0591L43.4199 35.0544C43.4142 35.0324 43.451 35.066 43.4487 35.0475L43.4338 35.0405C43.4649 35.0405 43.4683 35.0196 43.4844 35.0115H43.4775L43.5098 34.9731C43.5063 34.9639 43.4764 34.9569 43.4902 34.9476C43.5155 34.9615 43.5144 34.929 43.5385 34.9546C43.5408 34.9406 43.5431 34.9186 43.5581 34.9162C43.5431 34.9162 43.5305 34.8942 43.5213 34.8977L43.5098 34.8837C43.4982 34.8768 43.5086 34.893 43.4971 34.8814L43.519 34.8628C43.5397 34.8651 43.5742 34.8721 43.5857 34.8582L43.5547 34.8396L43.6157 34.8512C43.6203 34.8466 43.5973 34.8373 43.6088 34.835L43.626 34.8396C43.626 34.835 43.6456 34.8233 43.6226 34.8059L43.6053 34.8013L43.6283 34.7873L43.6249 34.785C43.6226 34.7757 43.6445 34.7757 43.656 34.792C43.6514 34.7943 43.641 34.7781 43.6445 34.7897C43.6606 34.7966 43.6709 34.7873 43.6779 34.7804L43.656 34.7711L43.7135 34.7548C43.7251 34.7641 43.6882 34.7455 43.694 34.7525C43.6882 34.7258 43.7377 34.7316 43.7239 34.7026L43.7366 34.7142L43.732 34.6933C43.7216 34.684 43.74 34.6886 43.7469 34.684H43.7366C43.7504 34.6817 43.7849 34.6608 43.7803 34.6364H43.8126L43.7976 34.6294L43.793 34.6039C43.8172 34.6085 43.7596 34.6271 43.7803 34.6271C43.7665 34.6132 43.8114 34.6271 43.7918 34.6132C43.7964 34.6062 43.8183 34.6085 43.8091 34.5946C43.8114 34.5969 43.7861 34.583 43.7884 34.5783L43.8103 34.576L43.8206 34.5737C43.8356 34.583 43.8252 34.5621 43.839 34.5783C43.8264 34.5667 43.8575 34.5667 43.8321 34.5493L43.8114 34.5377L43.846 34.547L43.839 34.54C43.8678 34.5609 43.8437 34.5261 43.8701 34.5354C43.8655 34.5168 43.8874 34.511 43.8736 34.4947C43.8897 34.4924 43.9047 34.4947 43.9047 34.4831L43.892 34.4785C43.8874 34.4669 43.8978 34.4715 43.9058 34.4715L43.8955 34.4355L43.9312 34.4576C43.9093 34.4285 43.9668 34.4506 43.9507 34.4239L43.9265 34.4123C43.907 34.3832 43.9599 34.4169 43.9565 34.396L43.9761 34.4169C43.9668 34.4007 44.0037 34.4123 43.9818 34.3937C43.9922 34.3983 43.983 34.3774 44.006 34.3983C44.0025 34.3647 44.0555 34.367 44.0256 34.324C44.0325 34.3263 44.0336 34.3147 44.0451 34.3287C44.052 34.3403 44.0302 34.3263 44.0382 34.3333L44.0486 34.338C44.0497 34.3287 44.052 34.324 44.0302 34.3124C44.0279 34.2903 44.0774 34.3356 44.0831 34.3124L44.0774 34.2985L44.1004 34.3031C44.105 34.2915 44.0854 34.2811 44.0716 34.2671L44.0958 34.2648L44.0843 34.2427C44.0935 34.259 44.0981 34.2497 44.1016 34.2497H44.0981L44.1062 34.2358L44.1108 34.2613L44.1349 34.2636C44.1177 34.252 44.1315 34.2451 44.1338 34.2404C44.1349 34.2334 44.1511 34.2474 44.1534 34.2451L44.1453 34.2288L44.1396 34.2381C44.1372 34.2288 44.1211 34.2172 44.1396 34.2195C44.1499 34.2218 44.1637 34.2462 44.166 34.2311L44.1453 34.2218L44.1476 34.2056L44.1603 34.2149L44.1534 34.2125C44.1706 34.2195 44.1729 34.2033 44.1879 34.2149L44.1902 34.1928H44.1868C44.1845 34.1789 44.196 34.1765 44.2086 34.1835L44.2052 34.1812L44.2259 34.1766C44.2201 34.1603 44.1787 34.1289 44.2029 34.1359C44.2109 34.1289 44.2363 34.1475 44.2432 34.158C44.2455 34.1371 44.2789 34.144 44.272 34.115L44.2858 34.1197C44.2984 34.0987 44.3376 34.0976 44.3272 34.0604L44.3077 34.0395C44.3226 34.0465 44.3007 34.0209 44.3215 34.0395L44.3364 34.0674C44.356 34.0628 44.371 34.0465 44.3652 34.0291L44.3779 34.043C44.3606 34.0244 44.3675 34.0117 44.3779 34.014L44.3894 34.0256L44.3825 34.0093C44.3894 34.0117 44.4078 34.0314 44.4032 34.014L44.394 34C44.4078 34.0024 44.432 34.0093 44.4297 33.9954L44.417 33.9733L44.4366 33.9849L44.4343 33.9397C44.4861 33.9559 44.5114 33.9257 44.5379 33.9083L44.531 33.9013C44.5299 33.8851 44.5471 33.913 44.5483 33.9013L44.523 33.8746C44.5241 33.8584 44.5483 33.8816 44.5563 33.8816C44.5702 33.8932 44.546 33.877 44.5586 33.8932C44.5644 33.8955 44.5644 33.8723 44.5817 33.8886L44.5586 33.8619L44.5725 33.8665C44.5633 33.841 44.5241 33.8433 44.5114 33.8119H44.5195C44.5091 33.7899 44.4873 33.8003 44.4953 33.7852C44.5091 33.7899 44.5356 33.8108 44.5368 33.8212C44.5529 33.8189 44.5759 33.8619 44.5897 33.8491C44.5863 33.8375 44.5771 33.8537 44.5667 33.8398C44.5621 33.8212 44.5874 33.8375 44.5886 33.8259L44.6162 33.8549C44.6162 33.8386 44.5966 33.8386 44.6047 33.8305C44.6162 33.8398 44.6312 33.8421 44.63 33.8549C44.6508 33.8758 44.6335 33.841 44.6542 33.8549C44.6438 33.8363 44.6128 33.8235 44.6174 33.8073C44.6289 33.8235 44.6485 33.8189 44.6611 33.8479L44.6404 33.8201C44.6392 33.8038 44.6795 33.8386 44.6565 33.8038L44.6726 33.8177L44.6646 33.7945C44.6703 33.7922 44.6991 33.8061 44.6807 33.7806C44.6841 33.7829 44.6968 33.7713 44.7049 33.7945C44.7049 33.8108 44.6864 33.7852 44.6991 33.8131C44.6911 33.7899 44.7141 33.8061 44.7221 33.8108L44.7152 33.7992L44.736 33.8061L44.7267 33.7899L44.7394 33.8038C44.7578 33.8038 44.721 33.7771 44.736 33.7748L44.7187 33.7678L44.7233 33.7539L44.7624 33.7875C44.7728 33.7875 44.7532 33.7713 44.7693 33.7806L44.7498 33.769L44.7463 33.7399C44.7532 33.7399 44.7751 33.7539 44.774 33.7666L44.7659 33.7434L44.7912 33.762L44.7832 33.7144L44.7578 33.6958L44.7636 33.6935C44.7429 33.6796 44.7567 33.6749 44.7383 33.6598L44.759 33.6621C44.7693 33.6981 44.8016 33.6935 44.8189 33.726C44.8396 33.7237 44.7786 33.6494 44.8258 33.683C44.8281 33.6923 44.8511 33.7097 44.8361 33.7074C44.8442 33.6981 44.8626 33.7306 44.8649 33.7121C44.8488 33.7074 44.8522 33.6784 44.8292 33.6691L44.8246 33.6807C44.8189 33.6645 44.8027 33.654 44.8119 33.6447C44.82 33.6447 44.8292 33.6377 44.8373 33.654C44.8499 33.6726 44.8258 33.6586 44.843 33.6726C44.8592 33.6703 44.8419 33.6436 44.8672 33.6726C44.8603 33.6749 44.8695 33.6912 44.8787 33.7016H44.8914L44.881 33.6946C44.8879 33.6761 44.8995 33.7109 44.911 33.697L44.9006 33.6726C44.8822 33.6563 44.8879 33.6946 44.8684 33.6633C44.8764 33.654 44.8891 33.6679 44.8914 33.6563L44.881 33.654C44.8833 33.6494 44.8592 33.6087 44.8856 33.625L44.9064 33.6436H44.9421C44.9248 33.6203 44.957 33.6296 44.9294 33.6145C44.9351 33.6308 44.9156 33.6412 44.8971 33.6261C44.8822 33.5971 44.8879 33.6354 44.8672 33.6122C44.8776 33.6029 44.8569 33.5785 44.8476 33.5599L44.8615 33.5646L44.881 33.5983C44.8914 33.5867 44.9087 33.5843 44.9259 33.5959L44.9064 33.5727L44.949 33.539C44.9559 33.5704 44.9674 33.5344 44.9754 33.5588L44.9904 33.6041L44.9824 33.5832C44.9973 33.5948 44.9743 33.5541 44.995 33.5739C44.9754 33.5739 44.9731 33.5448 44.9582 33.5239C44.9754 33.5286 44.9444 33.51 44.9559 33.503L45.0054 33.5054C45.0042 33.4787 45.0376 33.4821 45.0503 33.474L45.0342 33.4287C45.0422 33.4241 45.0457 33.4601 45.0491 33.4427L45.0445 33.438C45.0514 33.438 45.0572 33.4067 45.0814 33.438L45.0606 33.4148H45.0722L45.0572 33.3962C45.0537 33.3718 45.0756 33.3869 45.0814 33.38L45.0871 33.4009C45.1078 33.4032 45.109 33.3823 45.124 33.3776L45.1148 33.3637L45.1274 33.3683C45.1159 33.3521 45.1171 33.3393 45.1309 33.3474L45.0883 33.3242L45.109 33.3556C45.1136 33.3695 45.0986 33.3742 45.0894 33.3625H45.1032C45.0917 33.3416 45.0848 33.3463 45.0733 33.3358L45.0814 33.3335L45.056 33.3312L45.0641 33.3509C45.0514 33.3323 45.0422 33.3323 45.0376 33.3463C45.0422 33.3707 45.01 33.3463 45.0008 33.3602L45.0434 33.3869L45.0342 33.4055L44.9916 33.3742L45.0008 33.3881C44.987 33.3858 44.9766 33.3672 44.9674 33.3788L44.9202 33.4241L44.9282 33.438C44.8995 33.4148 44.8937 33.445 44.8741 33.4427C44.8661 33.4659 44.8258 33.4566 44.8327 33.4856C44.7924 33.4972 44.7578 33.5065 44.7279 33.5356L44.7486 33.5495C44.7314 33.5402 44.7521 33.5634 44.7429 33.5658C44.7394 33.546 44.721 33.5541 44.7106 33.5437C44.7037 33.5681 44.6749 33.5658 44.6519 33.5623L44.6623 33.5762C44.63 33.5623 44.6277 33.5948 44.6162 33.6099L44.6174 33.6308C44.5932 33.6192 44.5897 33.6215 44.5656 33.6192L44.5402 33.6575C44.4804 33.6528 44.4585 33.6958 44.409 33.7074L44.4182 33.7237C44.3514 33.7167 44.3376 33.7829 44.2973 33.7945L44.3192 33.8154C44.3192 33.834 44.2973 33.8317 44.2812 33.8108C44.28 33.827 44.2524 33.8224 44.2627 33.8444C44.2581 33.8584 44.242 33.8468 44.2317 33.8491C44.2236 33.877 44.2132 33.8804 44.1948 33.8944L44.196 33.8874L44.2121 33.906C44.1971 33.906 44.1937 33.935 44.1741 33.9013C44.1741 33.935 44.1211 33.9281 44.1246 33.9675L44.105 33.9582C44.0889 33.9745 44.0877 34.0059 44.0636 34.0059L44.0762 34.0221L44.0555 34.0151C44.0175 34.0244 44.021 34.079 43.9933 34.0964C43.9392 34.1255 43.9035 34.1731 43.8632 34.2102L43.8701 34.2149C43.8333 34.2102 43.8621 34.2671 43.8183 34.2462C43.8218 34.2555 43.8103 34.2625 43.8229 34.2694C43.7964 34.2671 43.8103 34.3101 43.7734 34.3101L43.7803 34.3078C43.7792 34.3322 43.7481 34.331 43.7435 34.3577L43.7608 34.3623C43.7665 34.3763 43.7205 34.3577 43.7469 34.3809L43.7308 34.3716L43.6306 34.4878C43.6295 34.533 43.6813 34.5261 43.6433 34.533H43.6364C43.6214 34.5354 43.6606 34.5714 43.6399 34.5644C43.6237 34.5481 43.626 34.5644 43.6168 34.5551C43.618 34.5818 43.6306 34.5981 43.6076 34.6027L43.618 34.6097C43.58 34.6074 43.58 34.6364 43.5385 34.6306L43.3255 34.9C43.2795 34.9998 43.1874 35.0742 43.1701 35.1903C43.1931 35.2286 43.1908 35.2309 43.1701 35.2542L43.1816 35.2565C43.1563 35.2472 43.1724 35.2751 43.1482 35.2681L43.1056 35.3842C43.1114 35.3819 43.1321 35.3842 43.1287 35.3889L43.1102 35.3935L43.1171 35.3958L43.0895 35.3935C43.0354 35.4887 43.0527 35.6048 43.0124 35.7047C43.0147 35.7314 42.9928 35.7616 42.9813 35.786C42.9893 35.8719 42.9962 35.9428 42.9456 36.0148C42.9467 36.0217 43.0181 36.024 43.0446 35.995Z",
    fill: "#67472D"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8824 32.7785C53.8824 32.7146 53.8087 32.7192 53.7926 32.6693C53.7903 32.6623 53.7765 32.6925 53.7719 32.6786C53.7627 32.6217 53.6936 32.5973 53.6337 32.5904L53.6314 32.5996C53.6199 32.5996 53.6279 32.5706 53.6153 32.5683L53.6084 32.5799C53.6141 32.5636 53.5957 32.5636 53.5992 32.5485L53.5784 32.5648L53.5842 32.5485C53.5922 32.5056 53.5473 32.53 53.5404 32.4986L53.5358 32.5102C53.5163 32.4673 53.4748 32.4464 53.4472 32.4173L53.4345 32.4406C53.4414 32.422 53.4334 32.4115 53.4253 32.4046C53.4115 32.4162 53.4195 32.3779 53.4011 32.379V32.3837C53.4034 32.3604 53.3827 32.386 53.3873 32.3604L53.3735 32.3697C53.3827 32.3453 53.3551 32.3744 53.3539 32.3604L53.3574 32.3535L53.3401 32.3465V32.3488C53.3263 32.3349 53.3125 32.3395 53.324 32.3244C53.3079 32.336 53.3332 32.3407 53.3136 32.3558C53.2779 32.3082 53.2296 32.2815 53.1801 32.2582L53.1605 32.2699L53.1455 32.2466L53.134 32.2536C53.1202 32.2582 53.134 32.2292 53.1202 32.2315L53.1144 32.2536C53.1144 32.2327 53.1018 32.2315 53.0937 32.2199L53.0926 32.2362C53.0903 32.2118 53.0695 32.2292 53.0661 32.2141L53.0649 32.2257C53.043 32.2327 53.0707 32.2013 53.0534 32.2037L53.0511 32.2176C53.0477 32.1909 53.0269 32.1886 53.0177 32.1746L53.0131 32.1793L52.9763 32.1549C52.9682 32.1572 52.9636 32.1816 52.9521 32.1735C52.9648 32.1491 52.9337 32.1503 52.9532 32.1305C52.9394 32.1282 52.9176 32.1259 52.9129 32.1143C52.9141 32.1259 52.8945 32.1375 52.9049 32.1456L52.8888 32.1549C52.8876 32.1665 52.8991 32.1572 52.8911 32.1688L52.8692 32.1503C52.8669 32.1317 52.8703 32.1003 52.8565 32.091L52.8439 32.1189L52.8404 32.069C52.8381 32.0643 52.8323 32.0852 52.8277 32.0783V32.0597C52.8231 32.062 52.807 32.0457 52.799 32.0666L52.7932 32.0806L52.7771 32.0643V32.069C52.7702 32.069 52.761 32.0527 52.7736 32.0423C52.7794 32.0446 52.7679 32.0562 52.7759 32.0516C52.7771 32.0376 52.7679 32.0283 52.7575 32.0237L52.7552 32.0423L52.7276 31.997C52.7299 31.9854 52.7253 32.0179 52.7287 32.0132C52.7057 32.0202 52.6999 31.9772 52.6758 31.9923L52.6815 31.9807C52.6712 31.9784 52.6654 31.9947 52.6631 31.9854C52.6585 31.9947 52.6562 31.9807 52.6493 31.9737C52.6504 31.9668 52.647 31.9784 52.6516 31.9807C52.6458 31.9714 52.617 31.9447 52.594 31.9494L52.586 31.925L52.5825 31.9389C52.5744 31.9436 52.5664 31.9319 52.5606 31.9436C52.5595 31.9203 52.5917 31.9703 52.5837 31.9528C52.5767 31.9645 52.5744 31.9238 52.5698 31.9436C52.5618 31.9389 52.5583 31.9203 52.5468 31.9296C52.548 31.9319 52.5457 31.9552 52.5364 31.9505L52.5284 31.9319L52.5238 31.925C52.5272 31.911 52.5111 31.9227 52.5215 31.9087C52.5146 31.9203 52.5054 31.8925 52.4973 31.918L52.495 31.9366L52.4892 31.9052L52.4846 31.9145C52.4938 31.8832 52.4697 31.9099 52.472 31.8855C52.457 31.8925 52.442 31.8785 52.4294 31.8948L52.4063 31.8739L52.4086 31.8855L52.3948 31.8762C52.3948 31.8809 52.3753 31.8901 52.366 31.8971L52.3695 31.8634C52.3534 31.8913 52.3499 31.8414 52.3327 31.8634L52.3315 31.8843C52.3142 31.911 52.32 31.86 52.3039 31.8704L52.3131 31.8449C52.3027 31.8588 52.297 31.8286 52.2935 31.8518C52.2901 31.8425 52.2751 31.8565 52.2808 31.8332C52.2544 31.8472 52.2302 31.8089 52.206 31.8449C52.2049 31.8402 52.1945 31.8425 52.1991 31.8286C52.2072 31.8193 52.2049 31.8402 52.2095 31.8332L52.2072 31.824C52.1991 31.8263 52.1922 31.824 52.1956 31.8472C52.1761 31.8588 52.1876 31.8042 52.1669 31.8089L52.1588 31.8181L52.1519 31.7996C52.1392 31.7996 52.1381 31.8205 52.1346 31.8332L52.1185 31.8147L52.1058 31.8332C52.1162 31.8193 52.1035 31.8216 52.1001 31.8193L52.1035 31.8216H52.0897L52.107 31.8054L52.0966 31.7891C52.0955 31.8054 52.0828 31.7961 52.0782 31.7984L52.0724 31.7821C52.069 31.7891 52.0609 31.7798 52.0632 31.7914L52.0713 31.7938C52.0667 31.8007 52.0632 31.8147 52.0575 31.8031C52.0529 31.7914 52.0667 31.7694 52.0517 31.7787L52.054 31.7972L52.0414 31.8019L52.0425 31.7856L52.0402 31.7926C52.0402 31.7763 52.0252 31.7833 52.0252 31.7647L52.0045 31.774L52.0057 31.7763C51.9965 31.7833 51.9896 31.7763 51.9838 31.7671L51.9688 31.7578C51.9585 31.7671 51.955 31.8123 51.9481 31.7914C51.9377 31.7891 51.9377 31.7624 51.9435 31.7554C51.9228 31.7624 51.909 31.7345 51.8894 31.7554L51.8871 31.7415C51.8606 31.7462 51.8353 31.716 51.8111 31.7438L51.8088 31.7682C51.8042 31.752 51.7996 31.7798 51.8007 31.7566L51.8111 31.7322C51.7973 31.7229 51.7731 31.7206 51.765 31.7299L51.7627 31.716C51.7604 31.7369 51.7501 31.7392 51.7432 31.7322V31.7183L51.7362 31.7322C51.7328 31.7276 51.7362 31.7032 51.7259 31.716L51.7224 31.7276C51.7121 31.716 51.7017 31.6985 51.6936 31.7067L51.6844 31.7252L51.681 31.7055C51.6637 31.7171 51.6534 31.7148 51.6487 31.7322C51.6234 31.6893 51.582 31.6776 51.5497 31.6823L51.5509 31.6939C51.5405 31.7032 51.5451 31.6753 51.5405 31.6823L51.5371 31.7136C51.5244 31.7252 51.5209 31.6951 51.5152 31.6927C51.5152 31.6811 51.5221 31.702 51.5198 31.6858C51.5209 31.6788 51.5025 31.6927 51.5014 31.6742V31.7032L51.4933 31.6962C51.4841 31.7171 51.514 31.7345 51.5037 31.7647L51.4968 31.7601C51.4876 31.781 51.514 31.7821 51.4968 31.7891C51.4899 31.7798 51.4829 31.7531 51.4899 31.7438C51.4737 31.7392 51.4841 31.6985 51.4691 31.6985C51.4622 31.7125 51.4818 31.7009 51.4783 31.7194C51.468 31.7357 51.4599 31.7102 51.453 31.7171L51.4507 31.6834L51.4438 31.7043C51.4403 31.6951 51.4311 31.6858 51.4392 31.6788C51.4346 31.6544 51.4277 31.6858 51.4185 31.6649C51.4162 31.6834 51.4323 31.7055 51.4185 31.7148C51.4219 31.6985 51.4012 31.6927 51.4093 31.6695L51.4081 31.6962C51.4001 31.7055 51.3885 31.6672 51.3862 31.6985L51.3828 31.68L51.3724 31.7009C51.3655 31.7032 51.3517 31.6776 51.3517 31.7055C51.3505 31.7009 51.3344 31.7032 51.3402 31.6846C51.3505 31.6707 51.3517 31.6962 51.3575 31.673C51.3494 31.6927 51.3436 31.6707 51.3367 31.6637L51.3356 31.673L51.3229 31.6614L51.3206 31.6753L51.316 31.6614C51.3022 31.6521 51.3137 31.6881 51.3022 31.6834L51.3114 31.6951L51.2999 31.702L51.2872 31.6614C51.2803 31.6544 51.2849 31.6776 51.2769 31.6637L51.2884 31.68C51.2895 31.6846 51.2826 31.7032 51.2711 31.7032C51.2642 31.6985 51.2538 31.68 51.2642 31.6695L51.2561 31.6904C51.2446 31.6858 51.2561 31.6742 51.2469 31.666L51.2262 31.7043L51.2377 31.7287L51.232 31.7264C51.2423 31.7473 51.2285 31.7427 51.2331 31.7624L51.2204 31.7531C51.2308 31.7194 51.1997 31.7102 51.2032 31.6788C51.1824 31.6718 51.1963 31.752 51.1744 31.7055C51.1767 31.6985 51.1652 31.6765 51.1778 31.6846C51.1675 31.6869 51.1675 31.6556 51.1548 31.666C51.1663 31.6776 51.1479 31.6951 51.164 31.716C51.1617 31.7043 51.1709 31.7043 51.1721 31.709C51.1686 31.7183 51.1755 31.738 51.1652 31.7403L51.1491 31.7194C51.1479 31.7009 51.1594 31.7194 51.1525 31.7032C51.1364 31.6985 51.1375 31.7241 51.1306 31.6962C51.1375 31.6962 51.1387 31.6776 51.1364 31.6672L51.126 31.6602L51.1295 31.6718C51.1134 31.6834 51.1226 31.6533 51.1053 31.6579L51.1007 31.6823C51.1076 31.7009 51.1226 31.6684 51.1237 31.7009C51.1145 31.7055 51.1088 31.6869 51.1007 31.6985L51.1088 31.7032C51.1053 31.7032 51.1053 31.7462 51.088 31.7264L51.0834 31.7032L51.05 31.6893C51.0546 31.7136 51.0293 31.6962 51.0454 31.7183C51.0489 31.702 51.0731 31.6997 51.0811 31.7206C51.0788 31.7485 51.0926 31.716 51.1007 31.7415C51.0857 31.7438 51.0903 31.7705 51.0915 31.7868L51.08 31.7821V31.7462C51.0673 31.7554 51.05 31.7485 51.0408 31.7345L51.0454 31.7589L50.9948 31.7705C51.0017 31.7438 50.974 31.7682 50.9787 31.7462C50.9867 31.7392 50.9925 31.7171 50.9844 31.7078L50.9856 31.7241C50.9764 31.7102 50.9775 31.7508 50.9683 31.7287C50.9856 31.7334 50.9752 31.7601 50.9821 31.7787C50.9683 31.7694 50.9856 31.7949 50.974 31.7972L50.9303 31.7787C50.9176 31.8007 50.8911 31.788 50.8762 31.788C50.8704 31.8019 50.8796 31.824 50.8727 31.8286C50.8647 31.8309 50.875 31.8042 50.8624 31.8147L50.8658 31.8193C50.8589 31.8147 50.8416 31.8402 50.8324 31.8077L50.8428 31.8298L50.8336 31.8251L50.8382 31.8472C50.8347 31.8658 50.8209 31.8472 50.8129 31.8472L50.8163 31.8309C50.7956 31.8216 50.7887 31.8402 50.7737 31.8379L50.776 31.8495L50.7657 31.8449C50.7714 31.8588 50.7668 31.8692 50.7564 31.8588L50.7875 31.8878L50.7772 31.8588C50.7783 31.8425 50.7933 31.8449 50.7979 31.8611L50.7887 31.8565C50.7898 31.875 50.799 31.8727 50.8071 31.8855H50.799L50.8232 31.8948L50.8186 31.8762C50.8232 31.8925 50.8347 31.8948 50.8439 31.8901C50.8474 31.8669 50.8693 31.8994 50.8796 31.8901L50.8497 31.8565L50.8681 31.8425L50.8923 31.8809L50.8911 31.8669C50.9027 31.8739 50.9061 31.8925 50.9176 31.8878L50.974 31.8692L50.9729 31.853C50.9879 31.8797 51.0051 31.8599 51.0201 31.8692C51.0374 31.853 51.065 31.8739 51.0731 31.8483L51.1813 31.8507L51.1721 31.8298C51.1813 31.8437 51.1755 31.8181 51.1836 31.8205C51.1755 31.8367 51.194 31.8414 51.1986 31.8518C51.2147 31.8356 51.2389 31.8541 51.2538 31.8681L51.255 31.8541C51.2699 31.8797 51.2861 31.8541 51.3068 31.8518L51.3172 31.8332C51.3298 31.8565 51.3333 31.8541 51.3482 31.8692L51.3885 31.853C51.4288 31.882 51.4703 31.8623 51.5117 31.8809L51.5152 31.8646C51.5555 31.8936 51.6073 31.8716 51.6407 31.8936L51.6395 31.8646C51.651 31.86 51.6637 31.8762 51.6603 31.8959C51.6718 31.889 51.6867 31.9122 51.6948 31.8913L51.7155 31.9099C51.7374 31.9029 51.7466 31.9052 51.7673 31.9145H51.7604L51.7662 31.8959C51.7742 31.9052 51.7973 31.8936 51.7846 31.9227C51.8122 31.9087 51.8353 31.9459 51.8617 31.9227L51.8641 31.9389C51.8848 31.9412 51.9078 31.9273 51.9216 31.9459L51.9285 31.9296L51.9297 31.9459C51.9596 31.9645 51.9988 31.9412 52.0252 31.9528C52.0724 31.9819 52.1266 31.9865 52.1761 32.0028L52.1772 31.9958C52.1864 32.0248 52.2221 31.9819 52.2244 32.0225C52.229 32.0156 52.2394 32.0225 52.2405 32.0086C52.2498 32.0272 52.282 32.0039 52.2958 32.0295L52.2924 32.0248C52.3154 32.0132 52.3257 32.0388 52.3476 32.0318L52.3465 32.0179C52.358 32.0086 52.3568 32.0492 52.3695 32.0202L52.3649 32.0341C52.4133 32.0365 52.4512 32.0748 52.4927 32.098C52.5295 32.091 52.5123 32.0504 52.5272 32.0817L52.5284 32.0864C52.5364 32.098 52.5549 32.0597 52.556 32.0771C52.5468 32.0934 52.5583 32.0887 52.5537 32.1003C52.5779 32.0957 52.5871 32.0794 52.5975 32.1003L52.5998 32.0887C52.6067 32.1224 52.6332 32.1177 52.6366 32.1549C52.7345 32.1932 52.8185 32.2524 52.9072 32.3047L53.1812 32.4336C53.2134 32.4243 53.2146 32.4266 53.2319 32.4522L53.2365 32.4406C53.2273 32.4615 53.2526 32.4545 53.2445 32.4742L53.3355 32.5335C53.3332 32.5288 53.3401 32.5126 53.3459 32.5172L53.3436 32.5335L53.3493 32.5288L53.3424 32.5485C53.4149 32.6171 53.5232 32.6275 53.5946 32.696C53.6164 32.703 53.6395 32.7297 53.6567 32.7483C53.7327 32.7692 53.8018 32.7912 53.8479 32.8528C53.8709 32.8551 53.902 32.8075 53.8824 32.7785Z",
    fill: "#67472D"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0965 29.6664C43.5201 27.4636 46.5758 25.6045 47.1435 25.1853C47.1435 25.1853 43.8333 24.5385 39.9969 25.0331C36.1629 25.5301 36.9516 25.6846 33.4906 28.8303C30.0342 31.9783 29.7556 33.2057 28.9346 35.4167C28.1137 37.623 26.6112 44.2071 25.7718 46.137C25.7949 46.3228 25.8605 46.8535 25.9722 47.2553C26.0769 47.2785 28.108 47.6338 32.8504 42.867C33.0197 42.3863 33.8636 40.0801 35.3558 37.4651C37.0322 34.5226 38.6752 31.8692 41.0965 29.6664Z",
    fill: "#E80C0C"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9797 28.1522C39.9797 28.1522 36.4047 30.2226 34.7628 35.5955C34.7628 35.5955 35.5009 30.3724 39.9797 28.1522Z",
    fill: "#AD071C"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1019 31.025C36.1019 31.025 32.1918 36.7428 33.0473 41.1565C33.0461 41.1565 31.4492 37.1573 36.1019 31.025Z",
    fill: "#AD071C"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8949 34.2439C44.5345 32.3859 45.6432 31.4221 46.6749 30.8415C47.1884 30.5535 47.6835 30.3608 48.2177 30.197C49.7582 29.736 50.2119 29.3551 50.8198 29.2692C50.8163 29.2669 50.8163 29.2646 50.8163 29.2646C50.8163 29.2646 52.1772 28.8976 51.9826 28.2009C51.7881 27.5019 50.7438 27.2011 49.5521 26.7018C48.3582 26.2025 48.2948 25.2793 46.3479 24.96C44.3986 24.6406 44.2927 25.2712 44.2927 25.2712C43.7999 25.652 41.0309 27.3103 39.0356 29.3191C37.0391 31.3304 36.004 33.7945 35.0092 36.5338C34.1227 38.9677 33.851 41.131 33.8003 41.5827C33.8061 41.5757 33.8118 41.5711 33.8164 41.5641L34.2804 42.3689C34.4808 42.3096 35.6344 41.9241 37.2659 40.5771C37.2648 40.5783 40.1271 37.3873 42.8949 34.2439Z",
    fill: "url(#paint1_linear_2395_11214)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5092 46.7107L30.1033 46.8535L30.3623 47.1461L30.0641 47.5073L30.3831 47.8359L29.356 48.0437L30.1597 48.4885L29.4079 48.586L29.0106 48.7021L29.3376 49.1539L29.6197 49.6927L28.7642 49.4093L28.6364 49.6323L28.4488 49.8065L28.5363 50.3847L28.1897 50.3801L27.7326 50.0468L27.8086 51.0246L27.4217 50.7981L27.1466 50.9561L26.8484 51.0083L26.526 51.3695L26.2888 50.5914L25.8927 51.1175L25.7051 50.6483L25.56 50.2651L25.2779 50.2396L25.1305 49.9783L24.8623 49.9017L24.0862 50.3127L24.6262 49.4116L23.8709 49.6323L24.4547 48.9379L23.2895 49.1991L23.8433 48.6452L23.6441 48.4072L23.4875 48.1355L23.4138 47.8382L23.0374 47.5154L23.3494 47.217L23.8226 47.0079L23.8744 46.7362L23.8951 46.4459L24.0137 46.187L24.1507 45.9373L23.9803 45.4275L24.8473 45.8351L25.0488 45.7039L24.754 44.8527L25.3435 45.2684L25.3597 44.6739L25.7822 44.9921L25.8467 44.1339L26.2048 44.2837L26.5064 44.0236L26.7954 45.1001L27.1189 44.4591L27.2548 45.1906L27.5979 44.8969L27.926 44.8144L28.0159 45.2452L28.7136 44.6693L28.8184 45.0664L28.4799 45.8537L29.0947 45.6447L29.5587 45.676L29.4551 46.108L29.2202 46.5365L29.5092 46.7107Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1213 47.2703C25.2065 46.6131 25.4886 46.2566 25.8052 46.0685C25.4057 46.2136 24.9981 46.5632 24.8945 47.3772C24.7114 48.795 25.91 50.0538 27.0061 49.4046C25.9779 49.7727 24.9498 48.5883 25.1213 47.2703Z",
    fill: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2395_11214)"
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0759 97.3214C48.1839 97.363 47.1849 96.7094 47.2198 95.8151C47.2558 94.9208 47.2558 94.6846 46.5786 94.0265C45.9014 93.3684 46.0791 92.6613 45.2951 92.4726C44.511 92.284 43.3344 92.3315 43.1566 92.0953C43.1566 92.0953 42.7291 90.1656 40.9462 90.3528C40.9462 90.3528 40.1981 87.9521 39.0923 88.328C39.0923 88.328 38.0225 87.6223 36.739 88.2344C35.4554 88.8464 35.3846 90.5414 35.4914 91.2946C35.5983 92.0478 35.3137 92.3775 34.992 92.0002C34.6714 91.6229 34.4925 90.4464 33.0312 90.9173C31.57 91.3882 30.9996 89.1287 29.6801 89.4109C28.3606 89.6932 29.5024 90.8697 27.8622 90.4003C26.2221 89.9294 25.1883 89.3173 25.1534 90.9188C25.1174 92.5187 24.3694 92.4726 23.9768 93.6967C23.5842 94.9208 23.6562 96.5682 23.9768 97.0392C24.2974 97.5101 24.4402 102.971 24.69 100.147C24.9397 97.3229 24.9757 96.286 25.3672 96.6633C25.7598 97.0406 25.474 96.4286 26.0444 96.1449C26.6147 95.8611 27.8622 93.8378 27.6845 95.6264C27.5068 97.415 27.7914 101.276 27.8982 99.2987C28.0051 97.3214 27.8622 94.4499 28.5754 94.6846C29.2886 94.9193 30.1087 95.5313 29.4664 96.803C28.8252 98.0746 29.9298 99.0149 29.6801 99.7696C29.4304 100.523 29.787 99.7933 29.787 102.242C29.787 104.69 30.3573 103.466 30.5002 96.7331C30.5564 94.0874 31.6768 95.3917 31.7477 96.9916C31.8186 98.5915 32.318 100.994 32.6386 99.8632C32.9592 98.7327 33.2798 94.2137 33.5656 95.2491C33.8513 96.2845 34.5994 97.1327 34.8851 96.1434C35.1708 95.154 35.3846 94.2597 35.776 95.2016C36.1686 96.1434 35.4194 102.121 36.1326 102.028C36.8458 101.934 35.9189 97.8384 36.5252 95.9547C37.1316 94.0711 37.595 94.6831 37.6659 95.2491C37.7368 95.8136 37.7728 98.4504 38.3791 97.6037C38.9854 96.7569 38.522 94.4959 39.0563 94.9208C39.5906 95.3442 39.6266 97.5101 40.1261 96.9916C40.6255 96.4732 40.269 94.637 40.8742 94.7797C41.4805 94.9208 41.2668 96.898 41.9788 96.286C42.692 95.674 43.0126 94.1676 43.3692 94.9208C43.7258 95.674 43.9036 94.9683 44.367 95.5328C44.8305 96.0973 45.258 96.9916 44.9014 97.4165C44.5448 97.8414 45.258 99.2051 45.1871 100.006C45.1162 100.806 45.5797 102.454 45.5797 101.371C45.5797 100.288 45.5797 98.7817 45.8654 98.1697C46.1511 97.5576 46.4717 97.1342 46.6135 97.6051C46.7563 98.0761 46.6844 99.0639 46.8992 99.3937C47.1129 99.7235 46.9701 101.277 47.2198 100.711C47.4695 100.147 47.3267 97.0392 48.0759 97.3214Z",
    fill: "#FEFDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask170_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 87,
    width: 26,
    height: 17
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0759 97.3214C48.1839 97.363 47.1849 96.7094 47.2198 95.8151C47.2558 94.9208 47.2558 94.6846 46.5786 94.0265C45.9014 93.3684 46.0791 92.6613 45.2951 92.4726C44.511 92.284 43.3344 92.3315 43.1566 92.0953C43.1566 92.0953 42.7291 90.1656 40.9462 90.3528C40.9462 90.3528 40.1981 87.9521 39.0923 88.328C39.0923 88.328 38.0225 87.6223 36.739 88.2344C35.4554 88.8464 35.3846 90.5414 35.4914 91.2946C35.5983 92.0478 35.3137 92.3775 34.992 92.0002C34.6714 91.6229 34.4925 90.4464 33.0312 90.9173C31.57 91.3882 30.9996 89.1287 29.6801 89.4109C28.3606 89.6932 29.5024 90.8697 27.8622 90.4003C26.2221 89.9294 25.1883 89.3173 25.1534 90.9188C25.1174 92.5187 24.3694 92.4726 23.9768 93.6967C23.5842 94.9208 23.6562 96.5682 23.9768 97.0392C24.2974 97.5101 24.4402 102.971 24.69 100.147C24.9397 97.3229 24.9757 96.286 25.3672 96.6633C25.7598 97.0406 25.474 96.4286 26.0444 96.1449C26.6147 95.8611 27.8622 93.8378 27.6845 95.6264C27.5068 97.415 27.7914 101.276 27.8982 99.2987C28.0051 97.3214 27.8622 94.4499 28.5754 94.6846C29.2886 94.9193 30.1087 95.5313 29.4664 96.803C28.8252 98.0746 29.9298 99.0149 29.6801 99.7696C29.4304 100.523 29.787 99.7933 29.787 102.242C29.787 104.69 30.3573 103.466 30.5002 96.7331C30.5564 94.0874 31.6768 95.3917 31.7477 96.9916C31.8186 98.5915 32.318 100.994 32.6386 99.8632C32.9592 98.7327 33.2798 94.2137 33.5656 95.2491C33.8513 96.2845 34.5994 97.1327 34.8851 96.1434C35.1708 95.154 35.3846 94.2597 35.776 95.2016C36.1686 96.1434 35.4194 102.121 36.1326 102.028C36.8458 101.934 35.9189 97.8384 36.5252 95.9547C37.1316 94.0711 37.595 94.6831 37.6659 95.2491C37.7368 95.8136 37.7728 98.4504 38.3791 97.6037C38.9854 96.7569 38.522 94.4959 39.0563 94.9208C39.5906 95.3442 39.6266 97.5101 40.1261 96.9916C40.6255 96.4732 40.269 94.637 40.8742 94.7797C41.4805 94.9208 41.2668 96.898 41.9788 96.286C42.692 95.674 43.0126 94.1676 43.3692 94.9208C43.7258 95.674 43.9036 94.9683 44.367 95.5328C44.8305 96.0973 45.258 96.9916 44.9014 97.4165C44.5448 97.8414 45.258 99.2051 45.1871 100.006C45.1162 100.806 45.5797 102.454 45.5797 101.371C45.5797 100.288 45.5797 98.7817 45.8654 98.1697C46.1511 97.5576 46.4717 97.1342 46.6135 97.6051C46.7563 98.0761 46.6844 99.0639 46.8992 99.3937C47.1129 99.7235 46.9701 101.277 47.2198 100.711C47.4695 100.147 47.3267 97.0392 48.0759 97.3214Z",
    fill: "white"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask170_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M47.5415 96.3098C47.5415 96.3098 47.3638 95.9801 46.7935 96.1687C46.2231 96.3574 45.7957 95.5567 45.7957 94.8035C45.7957 94.0503 46.6866 93.2496 45.8665 93.3447C45.0465 93.4383 43.9767 93.8632 43.6212 93.2972C43.2646 92.7327 42.8371 93.4383 42.4097 93.0625C41.9822 92.6851 41.9822 91.6037 40.9124 91.415C39.8426 91.2263 38.3453 88.2137 37.775 89.8611C37.2047 91.5086 36.3137 91.5561 35.4937 91.2977C34.6736 91.0392 36.1 93.4873 35.2799 93.9107C34.4599 94.3341 34.1393 92.2632 33.0346 92.9213C31.9299 93.5809 30.3967 90.0973 29.4697 91.3214C28.5428 92.5455 29.0063 94.5227 27.6159 93.5334C26.2255 92.544 26.0826 94.6163 25.2985 93.8632C24.5145 93.11 23.4447 92.5916 23.0881 93.1575C22.7315 93.722 21.7686 100.454 21.7686 100.454L27.6508 105.069L36.3486 106.905L49.716 103.559L51.3201 99.0878L47.5415 96.3098Z",
    fill: "#D8ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M48.0759 96.4034C47.933 96.451 47.2198 96.6857 47.2558 98.0034C47.2918 99.321 47.1489 98.2381 46.8632 97.2502C46.5775 96.2623 46.0071 96.8268 45.7934 97.5325C45.5797 98.2381 45.1871 98.9452 45.2231 97.8147C45.2591 96.6842 45.3299 95.6488 44.6887 95.2254C44.0475 94.802 43.8327 95.1779 43.5481 94.5198C43.2623 93.8602 42.8349 93.9077 42.4434 94.6609C42.0508 95.4141 42.0159 95.7914 41.5525 94.6609C41.089 93.5304 40.1261 95.273 39.6986 94.8496C39.2711 94.4262 39.5917 93.4368 40.3398 93.4368C41.0879 93.4368 41.1959 93.1546 41.6942 93.3432C42.1925 93.5319 42.2285 92.3078 41.6233 92.4014C41.017 92.495 40.3398 92.3539 40.1621 91.8369C39.9843 91.3185 39.0214 90.237 38.5219 91.1313C38.0225 92.0256 38.4151 93.1561 37.8087 93.0149C37.2024 92.8738 36.7749 96.451 36.0977 94.8035C35.4205 93.1561 34.8862 96.4034 34.2799 95.5092C33.6735 94.6149 32.9604 93.7206 32.7466 95.6503C32.5329 97.58 32.39 98.0984 32.0334 95.9325C31.6768 93.7666 30.8219 95.885 30.2864 95.1794C29.7521 94.4737 28.6463 93.7666 28.148 94.2375C27.6485 94.7085 27.221 93.7191 26.7216 94.4723C26.2221 95.2254 25.7586 96.7793 25.1534 95.885C24.5471 94.9907 23.9768 96.2148 24.2265 94.9432C24.4762 93.6715 23.3356 92.9184 23.8699 92.2603C24.4042 91.6007 21.5886 95.1794 21.5886 95.1794L20.8045 102.005L27.7565 108.267L42.4794 106.572L50.8927 104.642L48.0759 96.4034Z",
    fill: "url(#paint2_linear_2395_11214)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2395_11214)"
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7421 95.8192C89.962 95.8607 87.9276 95.2071 87.9986 94.3128C88.0719 93.4185 88.0719 93.1823 86.6928 92.5242C85.3136 91.8661 85.6756 91.159 84.0787 90.9704C82.4819 90.7817 80.0855 90.8292 79.7236 90.593C79.7236 90.593 78.853 88.6633 75.2218 88.8505C75.2218 88.8505 73.6983 86.4499 71.4462 86.8257C71.4462 86.8257 69.2675 86.1201 66.6535 86.7321C64.0394 87.3442 63.8951 89.0392 64.1128 89.7923C64.3304 90.5455 63.7508 90.8753 63.0956 90.498C62.4426 90.1206 62.0784 88.9441 59.1024 89.415C56.1264 89.8859 54.9648 87.6264 52.2775 87.9087C49.5902 88.1909 51.9155 89.3675 48.5753 88.898C45.235 88.4271 43.1296 87.8151 43.0586 89.4165C42.9853 91.0164 41.4618 90.9704 40.6622 92.1944C39.8626 93.4185 40.0093 95.066 40.6622 95.5369C41.3151 96.0078 41.6061 101.469 42.1147 98.6446C42.6233 95.8206 42.6966 94.7837 43.4939 95.1611C44.2934 95.5384 43.7115 94.9263 44.873 94.6426C46.0346 94.3589 48.5753 92.3356 48.2133 94.1242C47.8513 95.9127 48.4309 99.7737 48.6486 97.7964C48.8662 95.8192 48.5753 92.9476 50.0278 93.1823C51.4802 93.417 53.1504 94.0291 51.8422 95.3007C50.5364 96.5723 52.7861 97.5127 52.2775 98.2673C51.7689 99.0205 52.4952 98.2911 52.4952 100.739C52.4952 103.187 53.6567 101.963 53.9476 95.2309C54.0622 92.5851 56.344 93.8894 56.4883 95.4894C56.6327 97.0893 57.6499 99.4914 58.3028 98.3609C58.9557 97.2304 59.6087 92.7114 60.1906 93.7468C60.7725 94.7823 62.296 95.6305 62.8779 94.6411C63.4598 93.6518 63.8951 92.7575 64.6924 93.6993C65.4919 94.6411 63.9661 100.619 65.4186 100.525C66.8711 100.432 64.9833 96.3361 66.2182 94.4525C67.453 92.5688 68.3969 93.1808 68.5412 93.7468C68.6856 94.3113 68.7589 96.9482 69.9937 96.1014C71.2286 95.2547 70.2847 92.9937 71.3729 93.4185C72.4611 93.8419 72.5344 96.0078 73.5516 95.4894C74.5688 94.9709 73.8426 93.1348 75.0751 93.2774C76.31 93.4185 75.8747 95.3958 77.3249 94.7837C78.7774 94.1717 79.4303 92.6654 80.1566 93.4185C80.8828 94.1717 81.2448 93.4661 82.1887 94.0306C83.1326 94.5951 84.0031 95.4894 83.2769 95.9142C82.5506 96.3391 84.0031 97.7028 83.8588 98.5035C83.7145 99.3042 84.6584 100.952 84.6584 99.8687C84.6584 98.7858 84.6584 97.2794 85.2403 96.6674C85.8222 96.0554 86.4751 95.632 86.7638 96.1029C87.0547 96.5738 86.9081 97.5617 87.3457 97.8915C87.781 98.2213 87.49 99.7751 87.9986 99.2091C88.5072 98.6446 88.2163 95.5369 89.7421 95.8192Z",
    fill: "#FEFDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask171_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 86,
    width: 50,
    height: 16
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7421 95.8192C89.962 95.8607 87.9276 95.2071 87.9986 94.3128C88.0719 93.4185 88.0719 93.1823 86.6928 92.5242C85.3136 91.8661 85.6756 91.159 84.0787 90.9704C82.4819 90.7817 80.0855 90.8292 79.7236 90.593C79.7236 90.593 78.853 88.6633 75.2218 88.8505C75.2218 88.8505 73.6983 86.4499 71.4462 86.8257C71.4462 86.8257 69.2675 86.1201 66.6535 86.7321C64.0394 87.3442 63.8951 89.0392 64.1128 89.7923C64.3304 90.5455 63.7508 90.8753 63.0956 90.498C62.4426 90.1206 62.0784 88.9441 59.1024 89.415C56.1264 89.8859 54.9648 87.6264 52.2775 87.9087C49.5902 88.1909 51.9155 89.3675 48.5753 88.898C45.235 88.4271 43.1296 87.8151 43.0586 89.4165C42.9853 91.0164 41.4618 90.9704 40.6622 92.1944C39.8626 93.4185 40.0093 95.066 40.6622 95.5369C41.3151 96.0078 41.6061 101.469 42.1147 98.6446C42.6233 95.8206 42.6966 94.7837 43.4939 95.1611C44.2934 95.5384 43.7115 94.9263 44.873 94.6426C46.0346 94.3589 48.5753 92.3356 48.2133 94.1242C47.8513 95.9127 48.4309 99.7737 48.6486 97.7964C48.8662 95.8192 48.5753 92.9476 50.0278 93.1823C51.4802 93.417 53.1504 94.0291 51.8422 95.3007C50.5364 96.5723 52.7861 97.5127 52.2775 98.2673C51.7689 99.0205 52.4952 98.2911 52.4952 100.739C52.4952 103.187 53.6567 101.963 53.9476 95.2309C54.0622 92.5851 56.344 93.8894 56.4883 95.4894C56.6327 97.0893 57.6499 99.4914 58.3028 98.3609C58.9557 97.2304 59.6087 92.7114 60.1906 93.7468C60.7725 94.7823 62.296 95.6305 62.8779 94.6411C63.4598 93.6518 63.8951 92.7575 64.6924 93.6993C65.4919 94.6411 63.9661 100.619 65.4186 100.525C66.8711 100.432 64.9833 96.3361 66.2182 94.4525C67.453 92.5688 68.3969 93.1808 68.5412 93.7468C68.6856 94.3113 68.7589 96.9482 69.9937 96.1014C71.2286 95.2547 70.2847 92.9937 71.3729 93.4185C72.4611 93.8419 72.5344 96.0078 73.5516 95.4894C74.5688 94.9709 73.8426 93.1348 75.0751 93.2774C76.31 93.4185 75.8747 95.3958 77.3249 94.7837C78.7774 94.1717 79.4303 92.6654 80.1566 93.4185C80.8828 94.1717 81.2448 93.4661 82.1887 94.0306C83.1326 94.5951 84.0031 95.4894 83.2769 95.9142C82.5506 96.3391 84.0031 97.7028 83.8588 98.5035C83.7145 99.3042 84.6584 100.952 84.6584 99.8687C84.6584 98.7858 84.6584 97.2794 85.2403 96.6674C85.8222 96.0554 86.4751 95.632 86.7638 96.1029C87.0547 96.5738 86.9081 97.5617 87.3457 97.8915C87.781 98.2213 87.49 99.7751 87.9986 99.2091C88.5072 98.6446 88.2163 95.5369 89.7421 95.8192Z",
    fill: "white"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask171_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M88.6538 94.8076C88.6538 94.8076 88.2919 94.4778 87.1303 94.6665C85.9688 94.8551 85.0982 94.0544 85.0982 93.3013C85.0982 92.5481 86.9127 91.7474 85.2426 91.8425C83.5724 91.936 81.3937 92.3609 80.6697 91.7949C79.9435 91.2304 79.0729 91.936 78.2023 91.5602C77.3318 91.1829 77.3318 90.1014 75.153 89.9127C72.9743 89.7241 69.925 86.7114 68.7635 88.3589C67.6019 90.0063 65.7875 90.0539 64.1173 89.7954C62.4472 89.5369 65.3522 91.9851 63.6821 92.4085C62.0119 92.8318 61.359 90.761 59.1092 91.4191C56.8595 92.0787 53.7369 88.5951 51.8491 89.8192C49.9613 91.0432 50.9052 93.0205 48.0735 92.0311C45.2419 91.0418 44.9509 93.1141 43.3541 92.3609C41.7573 91.6077 39.5786 91.0893 38.8523 91.6553C38.1261 92.2198 36.165 98.9522 36.165 98.9522L48.1446 103.566L65.8585 105.402L93.0823 102.057L96.3493 97.5855L88.6538 94.8076Z",
    fill: "#D8ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M89.7421 94.9012C89.4511 94.9487 87.9986 95.1834 88.0719 96.5011C88.1452 97.8188 87.8543 96.7358 87.2724 95.7479C86.6905 94.7601 85.5289 95.3246 85.0936 96.0302C84.6584 96.7358 83.8588 97.4429 83.9321 96.3124C84.0054 95.182 84.1498 94.1465 82.8439 93.7232C81.538 93.2998 81.1005 93.6756 80.5208 93.0175C79.9389 92.358 79.0683 92.4055 78.2711 93.1587C77.4715 93.9118 77.4005 94.2891 76.4566 93.1587C75.5127 92.0282 73.5516 93.7707 72.6811 93.3473C71.8105 92.9239 72.4634 91.9346 73.9869 91.9346C75.5104 91.9346 75.7304 91.6523 76.7453 91.841C77.7602 92.0296 77.8335 90.8056 76.6009 90.8992C75.3661 90.9927 73.9869 90.8516 73.625 90.3347C73.263 89.8162 71.3019 88.7347 70.2847 89.629C69.2675 90.5233 70.067 91.6538 68.8322 91.5127C67.5974 91.3716 66.7268 94.9487 65.3476 93.3013C63.9684 91.6538 62.8802 94.9012 61.6454 94.0069C60.4105 93.1126 58.958 92.2183 58.5227 94.148C58.0875 96.0777 57.7965 96.5962 57.0703 94.4303C56.344 92.2644 54.6029 94.3827 53.5124 93.6771C52.4241 92.9715 50.1721 92.2644 49.1572 92.7353C48.14 93.2062 47.2694 92.2168 46.2522 92.97C45.235 93.7232 44.2911 95.277 43.0586 94.3827C41.8237 93.4884 40.6622 94.7125 41.1708 93.4409C41.6794 92.1693 39.3563 91.4161 40.4445 90.758C41.5328 90.0985 35.7984 93.6771 35.7984 93.6771L34.2016 100.503L48.3599 106.765L78.3444 105.07L95.4787 103.14L89.7421 94.9012Z",
    fill: "url(#paint3_linear_2395_11214)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2395_11214)"
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M148.866 99.5152C149.112 99.5599 146.834 98.8578 146.913 97.8973C146.995 96.9368 146.995 96.6831 145.451 95.9762C143.907 95.2694 144.312 94.5099 142.524 94.3073C140.736 94.1046 138.053 94.1557 137.647 93.902C137.647 93.902 136.672 91.8293 132.606 92.0304C132.606 92.0304 130.9 89.4519 128.379 89.8556C128.379 89.8556 125.939 89.0977 123.012 89.7551C120.085 90.4125 119.923 92.233 120.167 93.042C120.411 93.8509 119.762 94.2051 119.028 93.7999C118.297 93.3946 117.889 92.1309 114.556 92.6367C111.224 93.1425 109.923 90.7156 106.914 91.0188C103.905 91.3219 106.509 92.5856 102.769 92.0814C99.0284 91.5756 96.6708 90.9183 96.5913 92.6383C96.5092 94.3567 94.8032 94.3073 93.9079 95.622C93.0126 96.9368 93.1768 98.7063 93.9079 99.2121C94.639 99.7179 94.9649 105.583 95.5344 102.55C96.1039 99.5168 96.186 98.4031 97.0787 98.8084C97.974 99.2137 97.3224 98.5563 98.6231 98.2515C99.9237 97.9468 102.769 95.7736 102.363 97.6947C101.958 99.6157 102.607 103.763 102.851 101.639C103.094 99.5152 102.769 96.431 104.395 96.6831C106.022 96.9352 107.892 97.5926 106.427 98.9584C104.965 100.324 107.484 101.334 106.914 102.145C106.345 102.954 107.158 102.17 107.158 104.8C107.158 107.429 108.459 106.115 108.784 98.8834C108.913 96.0417 111.468 97.4426 111.629 99.161C111.791 100.879 112.93 103.459 113.661 102.245C114.392 101.031 115.123 96.1773 115.775 97.2894C116.427 98.4015 118.133 99.3126 118.784 98.2499C119.436 97.1873 119.923 96.2267 120.816 97.2383C121.711 98.2499 120.003 104.671 121.629 104.57C123.256 104.469 121.142 100.07 122.525 98.0473C123.907 96.0241 124.964 96.6815 125.126 97.2894C125.287 97.8957 125.369 100.728 126.752 99.8184C128.135 98.9089 127.078 96.4804 128.297 96.9368C129.515 97.3915 129.597 99.7179 130.736 99.161C131.875 98.6041 131.062 96.632 132.442 96.7852C133.825 96.9368 133.337 99.0605 134.961 98.4031C136.588 97.7457 137.319 96.1278 138.132 96.9368C138.945 97.7457 139.351 96.9878 140.408 97.5941C141.465 98.2005 142.439 99.161 141.626 99.6173C140.813 100.074 142.439 101.538 142.278 102.398C142.116 103.258 143.173 105.028 143.173 103.865C143.173 102.702 143.173 101.084 143.825 100.426C144.476 99.7689 145.207 99.3142 145.531 99.82C145.856 100.326 145.692 101.387 146.182 101.741C146.67 102.095 146.344 103.764 146.913 103.156C147.483 102.55 147.157 99.2121 148.866 99.5152Z",
    fill: "#FEFDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask172_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 89,
    width: 56,
    height: 18
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M148.866 99.5152C149.112 99.5599 146.834 98.8578 146.913 97.8973C146.995 96.9368 146.995 96.6831 145.451 95.9762C143.907 95.2694 144.312 94.5099 142.524 94.3073C140.736 94.1046 138.053 94.1557 137.647 93.902C137.647 93.902 136.672 91.8293 132.606 92.0304C132.606 92.0304 130.9 89.4519 128.379 89.8556C128.379 89.8556 125.939 89.0977 123.012 89.7551C120.085 90.4125 119.923 92.233 120.167 93.042C120.411 93.8509 119.762 94.2051 119.028 93.7999C118.297 93.3946 117.889 92.1309 114.556 92.6367C111.224 93.1425 109.923 90.7156 106.914 91.0188C103.905 91.3219 106.509 92.5856 102.769 92.0814C99.0284 91.5756 96.6708 90.9183 96.5913 92.6383C96.5092 94.3567 94.8032 94.3073 93.9079 95.622C93.0126 96.9368 93.1768 98.7063 93.9079 99.2121C94.639 99.7179 94.9649 105.583 95.5344 102.55C96.1039 99.5168 96.186 98.4031 97.0787 98.8084C97.974 99.2137 97.3224 98.5563 98.6231 98.2515C99.9237 97.9468 102.769 95.7736 102.363 97.6947C101.958 99.6157 102.607 103.763 102.851 101.639C103.094 99.5152 102.769 96.431 104.395 96.6831C106.022 96.9352 107.892 97.5926 106.427 98.9584C104.965 100.324 107.484 101.334 106.914 102.145C106.345 102.954 107.158 102.17 107.158 104.8C107.158 107.429 108.459 106.115 108.784 98.8834C108.913 96.0417 111.468 97.4426 111.629 99.161C111.791 100.879 112.93 103.459 113.661 102.245C114.392 101.031 115.123 96.1773 115.775 97.2894C116.427 98.4015 118.133 99.3126 118.784 98.2499C119.436 97.1873 119.923 96.2267 120.816 97.2383C121.711 98.2499 120.003 104.671 121.629 104.57C123.256 104.469 121.142 100.07 122.525 98.0473C123.907 96.0241 124.964 96.6815 125.126 97.2894C125.287 97.8957 125.369 100.728 126.752 99.8184C128.135 98.9089 127.078 96.4804 128.297 96.9368C129.515 97.3915 129.597 99.7179 130.736 99.161C131.875 98.6041 131.062 96.632 132.442 96.7852C133.825 96.9368 133.337 99.0605 134.961 98.4031C136.588 97.7457 137.319 96.1278 138.132 96.9368C138.945 97.7457 139.351 96.9878 140.408 97.5941C141.465 98.2005 142.439 99.161 141.626 99.6173C140.813 100.074 142.439 101.538 142.278 102.398C142.116 103.258 143.173 105.028 143.173 103.865C143.173 102.702 143.173 101.084 143.825 100.426C144.476 99.7689 145.207 99.3142 145.531 99.82C145.856 100.326 145.692 101.387 146.182 101.741C146.67 102.095 146.344 103.764 146.913 103.156C147.483 102.55 147.157 99.2121 148.866 99.5152Z",
    fill: "white"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask172_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M147.647 98.4287C147.647 98.4287 147.242 98.0745 145.941 98.2771C144.64 98.4797 143.666 97.6197 143.666 96.8108C143.666 96.0018 145.697 95.1418 143.827 95.2439C141.957 95.3444 139.517 95.8008 138.707 95.1929C137.894 94.5865 136.919 95.3444 135.944 94.9408C134.969 94.5355 134.969 93.3739 132.529 93.1713C130.09 92.9686 126.675 89.7328 125.375 91.5023C124.074 93.2718 122.042 93.3228 120.172 93.0452C118.302 92.7676 121.555 95.3971 119.685 95.8518C117.814 96.3066 117.083 94.0823 114.564 94.7892C112.045 95.4976 108.548 91.756 106.435 93.0707C104.321 94.3855 105.378 96.5092 102.207 95.4466C99.0361 94.3839 98.7103 96.6097 96.9222 95.8008C95.1341 94.9918 92.6945 94.435 91.8813 95.0429C91.0681 95.6492 88.8721 102.88 88.8721 102.88L102.286 107.836L122.122 109.808L152.606 106.215L156.264 101.412L147.647 98.4287Z",
    fill: "#D8ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M148.866 98.5292C148.54 98.5802 146.913 98.8323 146.995 100.248C147.078 101.663 146.752 100.5 146.1 99.4387C145.449 98.3776 144.148 98.9839 143.661 99.7418C143.173 100.5 142.278 101.259 142.36 100.045C142.442 98.8307 142.604 97.7186 141.141 97.2639C139.679 96.8091 139.189 97.2128 138.54 96.506C137.888 95.7975 136.914 95.8486 136.021 96.6576C135.126 97.4665 135.046 97.8718 133.989 96.6576C132.932 95.4433 130.736 97.3149 129.761 96.8602C128.787 96.4055 129.518 95.3428 131.224 95.3428C132.93 95.3428 133.176 95.0397 134.312 95.2423C135.449 95.4449 135.531 94.1302 134.151 94.2307C132.768 94.3312 131.224 94.1796 130.818 93.6244C130.413 93.0675 128.217 91.9059 127.078 92.8665C125.939 93.827 126.834 95.0412 125.452 94.8897C124.069 94.7381 123.094 98.5802 121.55 96.8107C120.005 95.0412 118.787 98.5292 117.404 97.5686C116.021 96.6081 114.395 95.6476 113.907 97.7202C113.42 99.7929 113.094 100.35 112.281 98.0234C111.468 95.697 109.518 97.9723 108.297 97.2144C107.078 96.4565 104.557 95.697 103.42 96.2028C102.281 96.7086 101.306 95.646 100.167 96.4549C99.0284 97.2639 97.9715 98.9329 96.5913 97.9723C95.2086 97.0118 93.9079 98.3265 94.4774 96.9607C95.0469 95.5949 92.4457 94.786 93.6642 94.0791C94.8828 93.3707 88.4617 97.2144 88.4617 97.2144L86.6736 104.546L102.528 111.271L136.103 109.451L155.289 107.378L148.866 98.5292Z",
    fill: "url(#paint4_linear_2395_11214)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2395_11214)"
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7878 99.9504C84.0077 99.992 81.9733 99.3383 82.0443 98.444C82.1177 97.5498 82.1177 97.3136 80.7385 96.6555C79.3593 95.9974 79.7213 95.2903 78.1245 95.1016C76.5276 94.9129 74.1313 94.9605 73.7693 94.7243C73.7693 94.7243 72.8987 92.7946 69.2675 92.9817C69.2675 92.9817 67.744 90.5811 65.4919 90.9569C65.4919 90.9569 63.3132 90.2513 60.6992 90.8634C58.0852 91.4754 57.9408 93.1704 58.1585 93.9236C58.3761 94.6767 57.7965 95.0065 57.1413 94.6292C56.4884 94.2519 56.1241 93.0753 53.1481 93.5462C50.1721 94.0171 49.0106 91.7576 46.3232 92.0399C43.6359 92.3222 45.9613 93.4987 42.621 93.0293C39.2807 92.5584 37.1753 91.9463 37.1043 93.5477C37.031 95.1476 35.5075 95.1016 34.7079 96.3257C33.9084 97.5498 34.055 99.1972 34.7079 99.6681C35.3609 100.139 35.6518 105.6 36.1604 102.776C36.669 99.9519 36.7423 98.915 37.5396 99.2923C38.3391 99.6696 37.7572 99.0576 38.9188 98.7738C40.0803 98.4901 42.621 96.4668 42.259 98.2554C41.8971 100.044 42.4767 103.905 42.6943 101.928C42.912 99.9504 42.621 97.0788 44.0735 97.3136C45.526 97.5483 47.1961 98.1603 45.888 99.4319C44.5821 100.704 46.8318 101.644 46.3232 102.399C45.8146 103.152 46.5409 102.422 46.5409 104.87C46.5409 107.319 47.7024 106.095 47.9934 99.3621C48.1079 96.7164 50.3897 98.0207 50.5341 99.6206C50.6784 101.221 51.6956 103.623 52.3485 102.492C53.0015 101.362 53.6544 96.8426 54.2363 97.8781C54.8182 98.9135 56.3417 99.7617 56.9236 98.7723C57.5056 97.783 57.9408 96.8887 58.7381 97.8305C59.5377 98.7723 58.0119 104.75 59.4644 104.657C60.9168 104.563 59.0291 100.467 60.2639 98.5837C61.4988 96.7 62.4426 97.3121 62.587 97.8781C62.7313 98.4426 62.8046 101.079 64.0395 100.233C65.2743 99.3859 64.3304 97.1249 65.4186 97.5498C66.5069 97.9731 66.5802 100.139 67.5974 99.6206C68.6146 99.1021 67.8883 97.266 69.1209 97.4086C70.3557 97.5498 69.9204 99.527 71.3706 98.915C72.8231 98.3029 73.476 96.7966 74.2023 97.5498C74.9285 98.3029 75.2905 97.5973 76.2344 98.1618C77.1783 98.7263 78.0489 99.6206 77.3226 100.045C76.5964 100.47 78.0489 101.834 77.9045 102.635C77.7602 103.435 78.7041 105.083 78.7041 104C78.7041 102.917 78.7041 101.411 79.286 100.799C79.8679 100.187 80.5208 99.7632 80.8095 100.234C81.1005 100.705 80.9538 101.693 81.3914 102.023C81.8267 102.352 81.5357 103.906 82.0443 103.34C82.5529 102.776 82.262 99.6681 83.7878 99.9504Z",
    fill: "#FEFDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask173_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 90,
    width: 50,
    height: 17
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7878 99.9504C84.0077 99.992 81.9733 99.3383 82.0443 98.444C82.1177 97.5498 82.1177 97.3136 80.7385 96.6555C79.3593 95.9974 79.7213 95.2903 78.1245 95.1016C76.5276 94.9129 74.1313 94.9605 73.7693 94.7243C73.7693 94.7243 72.8987 92.7946 69.2675 92.9817C69.2675 92.9817 67.744 90.5811 65.4919 90.9569C65.4919 90.9569 63.3132 90.2513 60.6992 90.8634C58.0852 91.4754 57.9408 93.1704 58.1585 93.9236C58.3761 94.6767 57.7965 95.0065 57.1413 94.6292C56.4884 94.2519 56.1241 93.0753 53.1481 93.5462C50.1721 94.0171 49.0106 91.7576 46.3232 92.0399C43.6359 92.3222 45.9613 93.4987 42.621 93.0293C39.2807 92.5584 37.1753 91.9463 37.1043 93.5477C37.031 95.1476 35.5075 95.1016 34.7079 96.3257C33.9084 97.5498 34.055 99.1972 34.7079 99.6681C35.3609 100.139 35.6518 105.6 36.1604 102.776C36.669 99.9519 36.7423 98.915 37.5396 99.2923C38.3391 99.6696 37.7572 99.0576 38.9188 98.7738C40.0803 98.4901 42.621 96.4668 42.259 98.2554C41.8971 100.044 42.4767 103.905 42.6943 101.928C42.912 99.9504 42.621 97.0788 44.0735 97.3136C45.526 97.5483 47.1961 98.1603 45.888 99.4319C44.5821 100.704 46.8318 101.644 46.3232 102.399C45.8146 103.152 46.5409 102.422 46.5409 104.87C46.5409 107.319 47.7024 106.095 47.9934 99.3621C48.1079 96.7164 50.3897 98.0207 50.5341 99.6206C50.6784 101.221 51.6956 103.623 52.3485 102.492C53.0015 101.362 53.6544 96.8426 54.2363 97.8781C54.8182 98.9135 56.3417 99.7617 56.9236 98.7723C57.5056 97.783 57.9408 96.8887 58.7381 97.8305C59.5377 98.7723 58.0119 104.75 59.4644 104.657C60.9168 104.563 59.0291 100.467 60.2639 98.5837C61.4988 96.7 62.4426 97.3121 62.587 97.8781C62.7313 98.4426 62.8046 101.079 64.0395 100.233C65.2743 99.3859 64.3304 97.1249 65.4186 97.5498C66.5069 97.9731 66.5802 100.139 67.5974 99.6206C68.6146 99.1021 67.8883 97.266 69.1209 97.4086C70.3557 97.5498 69.9204 99.527 71.3706 98.915C72.8231 98.3029 73.476 96.7966 74.2023 97.5498C74.9285 98.3029 75.2905 97.5973 76.2344 98.1618C77.1783 98.7263 78.0489 99.6206 77.3226 100.045C76.5964 100.47 78.0489 101.834 77.9045 102.635C77.7602 103.435 78.7041 105.083 78.7041 104C78.7041 102.917 78.7041 101.411 79.286 100.799C79.8679 100.187 80.5208 99.7632 80.8095 100.234C81.1005 100.705 80.9538 101.693 81.3914 102.023C81.8267 102.352 81.5357 103.906 82.0443 103.34C82.5529 102.776 82.262 99.6681 83.7878 99.9504Z",
    fill: "white"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask173_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M82.6996 98.9388C82.6996 98.9388 82.3376 98.609 81.1761 98.7977C80.0145 98.9864 79.144 98.1857 79.144 97.4325C79.144 96.6793 80.9584 95.8786 79.2883 95.9737C77.6182 96.0673 75.4394 96.4921 74.7155 95.9261C73.9892 95.3616 73.1187 96.0673 72.2481 95.6914C71.3775 95.3141 71.3775 94.2326 69.1988 94.044C67.02 93.8553 63.9707 90.8426 62.8092 92.4901C61.6477 94.1376 59.8332 94.1851 58.1631 93.9266C56.4929 93.6681 59.3979 96.1163 57.7278 96.5397C56.0577 96.9631 55.4047 94.8922 53.155 95.5503C50.9052 96.2099 47.7826 92.7263 45.8948 93.9504C44.0071 95.1745 44.9509 97.1517 42.1193 96.1623C39.2876 95.173 38.9967 97.2453 37.3998 96.4921C35.803 95.739 33.6243 95.2205 32.898 95.7865C32.1718 96.351 30.2107 103.083 30.2107 103.083L42.1903 107.698L59.9042 109.534L87.1281 106.188L90.395 101.717L82.6996 98.9388Z",
    fill: "#D8ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M83.7878 99.0324C83.4968 99.08 82.0443 99.3147 82.1177 100.632C82.191 101.95 81.9 100.867 81.3181 99.8792C80.7362 98.8913 79.5747 99.4558 79.1394 100.161C78.7041 100.867 77.9045 101.574 77.9778 100.444C78.0512 99.3132 78.1955 98.2778 76.8896 97.8544C75.5838 97.431 75.1462 97.8068 74.5666 97.1488C73.9846 96.4892 73.1141 96.5367 72.3168 97.2899C71.5173 98.043 71.4462 98.4204 70.5023 97.2899C69.5585 96.1594 67.5974 97.9019 66.7268 97.4785C65.8562 97.0552 66.5091 96.0658 68.0327 96.0658C69.5562 96.0658 69.7761 95.7835 70.791 95.9722C71.8059 96.1609 71.8792 94.9368 70.6467 95.0304C69.4118 95.124 68.0327 94.9828 67.6707 94.4659C67.3087 93.9474 65.3476 92.866 64.3304 93.7602C63.3132 94.6545 64.1128 95.785 62.8779 95.6439C61.6431 95.5028 60.7725 99.08 59.3933 97.4325C58.0142 95.785 56.9259 99.0324 55.6911 98.1381C54.4563 97.2438 53.0038 96.3495 52.5685 98.2792C52.1332 100.209 51.8422 100.727 51.116 98.5615C50.3897 96.3956 48.6486 98.514 47.5581 97.8083C46.4699 97.1027 44.2178 96.3956 43.2029 96.8665C42.1857 97.3374 41.3151 96.3481 40.2979 97.1012C39.2807 97.8544 38.3369 99.4083 37.1043 98.514C35.8695 97.6197 34.7079 98.8438 35.2165 97.5721C35.7251 96.3005 33.4021 95.5473 34.4903 94.8893C35.5785 94.2297 29.8442 97.8083 29.8442 97.8083L28.2473 104.634L42.4057 110.896L72.3901 109.201L89.5244 107.271L83.7878 99.0324Z",
    fill: "url(#paint5_linear_2395_11214)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_2395_11214)"
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1779 99.5748C93.3702 99.6164 91.5916 98.9628 91.6537 98.0685C91.7178 97.1742 91.7178 96.938 90.512 96.2799C89.3063 95.6218 89.6227 94.9147 88.2267 94.726C86.8307 94.5374 84.7357 94.5849 84.4192 94.3487C84.4192 94.3487 83.6581 92.419 80.4835 92.6062C80.4835 92.6062 79.1516 90.2056 77.1827 90.5814C77.1827 90.5814 75.278 89.8758 72.9927 90.4878C70.7074 91.0998 70.5812 92.7948 70.7714 93.548C70.9617 94.3012 70.455 94.631 69.8822 94.2536C69.3113 93.8763 68.9929 92.6998 66.3911 93.1707C63.7893 93.6416 62.7739 91.3821 60.4245 91.6644C58.0751 91.9466 60.108 93.1231 57.1878 92.6537C54.2675 92.1828 52.4269 91.5708 52.3648 93.1722C52.3007 94.7721 50.9688 94.726 50.2698 95.9501C49.5707 97.1742 49.6989 98.8217 50.2698 99.2926C50.8406 99.7635 51.095 105.224 51.5396 102.4C51.9842 99.5763 52.0483 98.5394 52.7453 98.9167C53.4444 99.2941 52.9356 98.682 53.9511 98.3983C54.9666 98.1145 57.1878 96.0912 56.8713 97.8798C56.5549 99.6684 57.0616 103.529 57.2519 101.552C57.4421 99.5748 57.1878 96.7033 58.4576 96.938C59.7275 97.1727 61.1876 97.7848 60.0439 99.0564C58.9023 100.328 60.8691 101.268 60.4245 102.023C59.9798 102.776 60.6147 102.047 60.6147 104.495C60.6147 106.943 61.6302 105.719 61.8846 98.9866C61.9847 96.3408 63.9796 97.6451 64.1058 99.245C64.232 100.845 65.1213 103.247 65.6921 102.117C66.2629 100.986 66.8337 96.4671 67.3425 97.5025C67.8512 98.5379 69.1831 99.3862 69.6919 98.3968C70.2006 97.4074 70.5812 96.5131 71.2782 97.455C71.9772 98.3968 70.6433 104.375 71.9131 104.281C73.1829 104.187 71.5325 100.092 72.6121 98.2081C73.6917 96.3245 74.5169 96.9365 74.6431 97.5025C74.7692 98.067 74.8333 100.704 75.9129 99.8571C76.9925 99.0103 76.1673 96.7493 77.1186 97.1742C78.07 97.5976 78.1341 99.7635 79.0234 99.245C79.9127 98.7266 79.2778 96.8905 80.3553 97.0331C81.4349 97.1742 81.0543 99.1515 82.3222 98.5394C83.592 97.9274 84.1628 96.421 84.7978 97.1742C85.4327 97.9274 85.7491 97.2217 86.5743 97.7862C87.3995 98.3507 88.1606 99.245 87.5257 99.6699C86.8908 100.095 88.1606 101.458 88.0344 102.259C87.9083 103.06 88.7335 104.707 88.7335 103.624C88.7335 102.541 88.7335 101.035 89.2422 100.423C89.7509 99.811 90.3218 99.3877 90.5741 99.8586C90.8285 100.329 90.7003 101.317 91.0829 101.647C91.4634 101.977 91.209 103.531 91.6537 102.965C92.0983 102.4 91.844 99.2926 93.1779 99.5748Z",
    fill: "#FEFDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask174_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 90,
    width: 45,
    height: 16
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1779 99.5748C93.3702 99.6164 91.5916 98.9628 91.6537 98.0685C91.7178 97.1742 91.7178 96.938 90.512 96.2799C89.3063 95.6218 89.6227 94.9147 88.2267 94.726C86.8307 94.5374 84.7357 94.5849 84.4192 94.3487C84.4192 94.3487 83.6581 92.419 80.4835 92.6062C80.4835 92.6062 79.1516 90.2056 77.1827 90.5814C77.1827 90.5814 75.278 89.8758 72.9927 90.4878C70.7074 91.0998 70.5812 92.7948 70.7714 93.548C70.9617 94.3012 70.455 94.631 69.8822 94.2536C69.3113 93.8763 68.9929 92.6998 66.3911 93.1707C63.7893 93.6416 62.7739 91.3821 60.4245 91.6644C58.0751 91.9466 60.108 93.1231 57.1878 92.6537C54.2675 92.1828 52.4269 91.5708 52.3648 93.1722C52.3007 94.7721 50.9688 94.726 50.2698 95.9501C49.5707 97.1742 49.6989 98.8217 50.2698 99.2926C50.8406 99.7635 51.095 105.224 51.5396 102.4C51.9842 99.5763 52.0483 98.5394 52.7453 98.9167C53.4444 99.2941 52.9356 98.682 53.9511 98.3983C54.9666 98.1145 57.1878 96.0912 56.8713 97.8798C56.5549 99.6684 57.0616 103.529 57.2519 101.552C57.4421 99.5748 57.1878 96.7033 58.4576 96.938C59.7275 97.1727 61.1876 97.7848 60.0439 99.0564C58.9023 100.328 60.8691 101.268 60.4245 102.023C59.9798 102.776 60.6147 102.047 60.6147 104.495C60.6147 106.943 61.6302 105.719 61.8846 98.9866C61.9847 96.3408 63.9796 97.6451 64.1058 99.245C64.232 100.845 65.1213 103.247 65.6921 102.117C66.2629 100.986 66.8337 96.4671 67.3425 97.5025C67.8512 98.5379 69.1831 99.3862 69.6919 98.3968C70.2006 97.4074 70.5812 96.5131 71.2782 97.455C71.9772 98.3968 70.6433 104.375 71.9131 104.281C73.1829 104.187 71.5325 100.092 72.6121 98.2081C73.6917 96.3245 74.5169 96.9365 74.6431 97.5025C74.7692 98.067 74.8333 100.704 75.9129 99.8571C76.9925 99.0103 76.1673 96.7493 77.1186 97.1742C78.07 97.5976 78.1341 99.7635 79.0234 99.245C79.9127 98.7266 79.2778 96.8905 80.3553 97.0331C81.4349 97.1742 81.0543 99.1515 82.3222 98.5394C83.592 97.9274 84.1628 96.421 84.7978 97.1742C85.4327 97.9274 85.7491 97.2217 86.5743 97.7862C87.3995 98.3507 88.1606 99.245 87.5257 99.6699C86.8908 100.095 88.1606 101.458 88.0344 102.259C87.9083 103.06 88.7335 104.707 88.7335 103.624C88.7335 102.541 88.7335 101.035 89.2422 100.423C89.7509 99.811 90.3218 99.3877 90.5741 99.8586C90.8285 100.329 90.7003 101.317 91.0829 101.647C91.4634 101.977 91.209 103.531 91.6537 102.965C92.0983 102.4 91.844 99.2926 93.1779 99.5748Z",
    fill: "white"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask174_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M92.2265 98.5633C92.2265 98.5633 91.9101 98.2335 90.8946 98.4221C89.8791 98.6108 89.118 97.8101 89.118 97.0569C89.118 96.3038 90.7043 95.5031 89.2442 95.5981C87.7841 95.6917 85.8793 96.1166 85.2464 95.5506C84.6115 94.9861 83.8504 95.6917 83.0893 95.3159C82.3282 94.9386 82.3282 93.8571 80.4234 93.6684C78.5187 93.4798 75.8528 90.4671 74.8373 92.1146C73.8219 93.762 72.2356 93.8096 70.7755 93.5511C69.3153 93.2926 71.855 95.7407 70.3949 96.1641C68.9348 96.5875 68.364 94.5167 66.3971 95.1748C64.4303 95.8343 61.7003 92.3508 60.0499 93.5748C58.3995 94.7989 59.2247 96.7762 56.7491 95.7868C54.2735 94.7974 54.0192 96.8698 52.6232 96.1166C51.2271 95.3634 49.3224 94.845 48.6875 95.411C48.0525 95.9755 46.3381 102.708 46.3381 102.708L56.8112 107.322L72.2977 109.158L96.0981 105.813L98.9543 101.341L92.2265 98.5633Z",
    fill: "#D8ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M93.1779 98.6569C92.9235 98.7044 91.6537 98.9391 91.7178 100.257C91.7819 101.574 91.5275 100.492 91.0188 99.5036C90.51 98.5157 89.4946 99.0802 89.114 99.7859C88.7335 100.492 88.0344 101.199 88.0985 100.068C88.1626 98.9376 88.2888 97.9022 87.1472 97.4788C86.0055 97.0555 85.623 97.4313 85.1162 96.7732C84.6075 96.1136 83.8464 96.1612 83.1494 96.9143C82.4504 97.6675 82.3883 98.0448 81.5631 96.9143C80.7379 95.7838 79.0234 97.5264 78.2623 97.103C77.5012 96.6796 78.072 95.6902 79.4039 95.6902C80.7359 95.6902 80.9282 95.408 81.8154 95.5967C82.7027 95.7853 82.7668 94.5612 81.6893 94.6548C80.6097 94.7484 79.4039 94.6073 79.0875 94.0903C78.771 93.5719 77.0565 92.4904 76.1673 93.3847C75.278 94.279 75.977 95.4095 74.8974 95.2684C73.8179 95.1272 73.0568 98.7044 71.851 97.0569C70.6453 95.4095 69.6939 98.6569 68.6143 97.7626C67.5348 96.8683 66.2649 95.974 65.8844 97.9037C65.5038 99.8334 65.2494 100.352 64.6145 98.186C63.9796 96.02 62.4574 98.1384 61.504 97.4328C60.5526 96.7272 58.5838 96.02 57.6965 96.491C56.8072 96.9619 56.0461 95.9725 55.1568 96.7257C54.2675 97.4788 53.4423 99.0327 52.3648 98.1384C51.2852 97.2441 50.2697 98.4682 50.7144 97.1966C51.159 95.925 49.1281 95.1718 50.0795 94.5137C51.0308 93.8541 46.0176 97.4328 46.0176 97.4328L44.6216 104.259L56.9995 110.52L83.2135 108.825L98.1932 106.896L93.1779 98.6569Z",
    fill: "url(#paint6_linear_2395_11214)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_2395_11214)"
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0931 99.5748C10.9008 99.6164 12.6794 98.9628 12.6173 98.0685C12.5532 97.1742 12.5532 96.938 13.759 96.2799C14.9647 95.6218 14.6482 94.9147 16.0443 94.726C17.4403 94.5374 19.5353 94.5849 19.8518 94.3487C19.8518 94.3487 20.6129 92.419 23.7875 92.6062C23.7875 92.6062 25.1194 90.2056 27.0883 90.5814C27.0883 90.5814 28.993 89.8758 31.2783 90.4878C33.5636 91.0998 33.6898 92.7948 33.4996 93.548C33.3093 94.3012 33.816 94.631 34.3888 94.2536C34.9597 93.8763 35.2781 92.6998 37.8799 93.1707C40.4817 93.6416 41.4971 91.3821 43.8465 91.6644C46.1959 91.9466 44.163 93.1231 47.0832 92.6537C50.0035 92.1828 51.8441 91.5708 51.9062 93.1722C51.9703 94.7721 53.3022 94.726 54.0012 95.9501C54.7003 97.1742 54.5721 98.8217 54.0012 99.2926C53.4304 99.7635 53.176 105.224 52.7314 102.4C52.2868 99.5763 52.2227 98.5394 51.5257 98.9167C50.8266 99.2941 51.3354 98.682 50.3199 98.3983C49.3044 98.1145 47.0832 96.0912 47.3997 97.8798C47.7161 99.6684 47.2094 103.529 47.0191 101.552C46.8289 99.5748 47.0832 96.7033 45.8134 96.938C44.5435 97.1727 43.0834 97.7848 44.2271 99.0564C45.3687 100.328 43.4019 101.268 43.8465 102.023C44.2912 102.776 43.6563 102.047 43.6563 104.495C43.6563 106.943 42.6408 105.719 42.3864 98.9866C42.2863 96.3408 40.2914 97.6451 40.1652 99.245C40.039 100.845 39.1497 103.247 38.5789 102.117C38.0081 100.986 37.4373 96.4671 36.9285 97.5025C36.4198 98.5379 35.0879 99.3862 34.5791 98.3968C34.0704 97.4074 33.6898 96.5131 32.9928 97.455C32.2938 98.3968 33.6277 104.375 32.3579 104.281C31.0881 104.187 32.7384 100.092 31.6589 98.2081C30.5793 96.3245 29.7541 96.9365 29.6279 97.5025C29.5018 98.067 29.4377 100.704 28.3581 99.8571C27.2785 99.0103 28.1037 96.7493 27.1524 97.1742C26.201 97.5976 26.1369 99.7635 25.2476 99.245C24.3583 98.7266 24.9932 96.8905 23.9157 97.0331C22.8361 97.1742 23.2167 99.1515 21.9488 98.5394C20.679 97.9274 20.1082 96.421 19.4732 97.1742C18.8383 97.9274 18.5219 97.2217 17.6967 97.7862C16.8715 98.3507 16.1104 99.245 16.7453 99.6699C17.3802 100.095 16.1104 101.458 16.2365 102.259C16.3627 103.06 15.5375 104.707 15.5375 103.624C15.5375 102.541 15.5375 101.035 15.0288 100.423C14.5201 99.811 13.9492 99.3877 13.6969 99.8586C13.4425 100.329 13.5707 101.317 13.1881 101.647C12.8076 101.977 13.062 103.531 12.6173 102.965C12.1727 102.4 12.427 99.2926 11.0931 99.5748Z",
    fill: "#FEFDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask175_2395_11214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 90,
    width: 44,
    height: 16
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0931 99.5748C10.9008 99.6164 12.6794 98.9628 12.6173 98.0685C12.5532 97.1742 12.5532 96.938 13.759 96.2799C14.9647 95.6218 14.6482 94.9147 16.0443 94.726C17.4403 94.5374 19.5353 94.5849 19.8518 94.3487C19.8518 94.3487 20.6129 92.419 23.7875 92.6062C23.7875 92.6062 25.1194 90.2056 27.0883 90.5814C27.0883 90.5814 28.993 89.8758 31.2783 90.4878C33.5636 91.0998 33.6898 92.7948 33.4996 93.548C33.3093 94.3012 33.816 94.631 34.3888 94.2536C34.9597 93.8763 35.2781 92.6998 37.8799 93.1707C40.4817 93.6416 41.4971 91.3821 43.8465 91.6644C46.1959 91.9466 44.163 93.1231 47.0832 92.6537C50.0035 92.1828 51.8441 91.5708 51.9062 93.1722C51.9703 94.7721 53.3022 94.726 54.0012 95.9501C54.7003 97.1742 54.5721 98.8217 54.0012 99.2926C53.4304 99.7635 53.176 105.224 52.7314 102.4C52.2868 99.5763 52.2227 98.5394 51.5257 98.9167C50.8266 99.2941 51.3354 98.682 50.3199 98.3983C49.3044 98.1145 47.0832 96.0912 47.3997 97.8798C47.7161 99.6684 47.2094 103.529 47.0191 101.552C46.8289 99.5748 47.0832 96.7033 45.8134 96.938C44.5435 97.1727 43.0834 97.7848 44.2271 99.0564C45.3687 100.328 43.4019 101.268 43.8465 102.023C44.2912 102.776 43.6563 102.047 43.6563 104.495C43.6563 106.943 42.6408 105.719 42.3864 98.9866C42.2863 96.3408 40.2914 97.6451 40.1652 99.245C40.039 100.845 39.1497 103.247 38.5789 102.117C38.0081 100.986 37.4373 96.4671 36.9285 97.5025C36.4198 98.5379 35.0879 99.3862 34.5791 98.3968C34.0704 97.4074 33.6898 96.5131 32.9928 97.455C32.2938 98.3968 33.6277 104.375 32.3579 104.281C31.0881 104.187 32.7384 100.092 31.6589 98.2081C30.5793 96.3245 29.7541 96.9365 29.6279 97.5025C29.5018 98.067 29.4377 100.704 28.3581 99.8571C27.2785 99.0103 28.1037 96.7493 27.1524 97.1742C26.201 97.5976 26.1369 99.7635 25.2476 99.245C24.3583 98.7266 24.9932 96.8905 23.9157 97.0331C22.8361 97.1742 23.2167 99.1515 21.9488 98.5394C20.679 97.9274 20.1082 96.421 19.4732 97.1742C18.8383 97.9274 18.5219 97.2217 17.6967 97.7862C16.8715 98.3507 16.1104 99.245 16.7453 99.6699C17.3802 100.095 16.1104 101.458 16.2365 102.259C16.3627 103.06 15.5375 104.707 15.5375 103.624C15.5375 102.541 15.5375 101.035 15.0288 100.423C14.5201 99.811 13.9492 99.3877 13.6969 99.8586C13.4425 100.329 13.5707 101.317 13.1881 101.647C12.8076 101.977 13.062 103.531 12.6173 102.965C12.1727 102.4 12.427 99.2926 11.0931 99.5748Z",
    fill: "white"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask175_2395_11214)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M12.0445 98.5633C12.0445 98.5633 12.3609 98.2335 13.3764 98.4221C14.3919 98.6108 15.153 97.8101 15.153 97.0569C15.153 96.3038 13.5667 95.5031 15.0268 95.5981C16.4869 95.6917 18.3917 96.1166 19.0246 95.5506C19.6595 94.9861 20.4206 95.6917 21.1817 95.3159C21.9428 94.9386 21.9428 93.8571 23.8476 93.6684C25.7523 93.4798 28.4182 90.4671 29.4337 92.1146C30.4491 93.762 32.0354 93.8096 33.4955 93.5511C34.9557 93.2926 32.416 95.7407 33.8761 96.1641C35.3362 96.5875 35.907 94.5167 37.8739 95.1748C39.8407 95.8343 42.5707 92.3508 44.2211 93.5748C45.8715 94.7989 45.0463 96.7762 47.5219 95.7868C49.9974 94.7974 50.2518 96.8698 51.6478 96.1166C53.0439 95.3634 54.9486 94.845 55.5835 95.411C56.2185 95.9755 57.9329 102.708 57.9329 102.708L47.4598 107.322L31.9733 109.158L8.17286 105.813L5.31673 101.341L12.0445 98.5633Z",
    fill: "#D8ECF5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M11.0931 98.6569C11.3475 98.7044 12.6173 98.9391 12.5532 100.257C12.4891 101.574 12.7435 100.492 13.2522 99.5036C13.761 98.5157 14.7764 99.0802 15.157 99.7859C15.5375 100.492 16.2365 101.199 16.1725 100.068C16.1084 98.9376 15.9822 97.9022 17.1238 97.4788C18.2655 97.0555 18.648 97.4313 19.1548 96.7732C19.6635 96.1136 20.4246 96.1612 21.1216 96.9143C21.8206 97.6675 21.8827 98.0448 22.7079 96.9143C23.5331 95.7838 25.2476 97.5264 26.0087 97.103C26.7698 96.6796 26.199 95.6902 24.867 95.6902C23.5351 95.6902 23.3428 95.408 22.4556 95.5967C21.5683 95.7853 21.5042 94.5612 22.5817 94.6548C23.6613 94.7484 24.867 94.6073 25.1835 94.0903C25.5 93.5719 27.2144 92.4904 28.1037 93.3847C28.993 94.279 28.294 95.4095 29.3736 95.2684C30.4531 95.1272 31.2142 98.7044 32.42 97.0569C33.6257 95.4095 34.5771 98.6569 35.6567 97.7626C36.7362 96.8683 38.0061 95.974 38.3866 97.9037C38.7672 99.8334 39.0215 100.352 39.6565 98.186C40.2914 96.02 41.8136 98.1384 42.767 97.4328C43.7184 96.7272 45.6872 96.02 46.5745 96.491C47.4638 96.9619 48.2249 95.9725 49.1142 96.7257C50.0035 97.4788 50.8287 99.0327 51.9062 98.1384C52.9858 97.2441 54.0012 98.4682 53.5566 97.1966C53.112 95.925 55.1429 95.1718 54.1915 94.5137C53.2401 93.8541 58.2534 97.4328 58.2534 97.4328L59.6494 104.259L47.2715 110.52L21.0575 108.825L6.07784 106.896L11.0931 98.6569Z",
    fill: "url(#paint7_linear_2395_11214)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2395_11214",
    x: -7.11942,
    y: -6.2981,
    width: 112.116,
    height: 122.464,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_2395_11214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2395_11214",
    x1: 39.1184,
    y1: 54.8537,
    x2: 58.0885,
    y2: 48.6888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2151B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5636,
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2151B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2395_11214",
    x1: 37.4606,
    y1: 29.7434,
    x2: 44.0641,
    y2: 35.9879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5636,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2395_11214",
    x1: 50.8927,
    y1: 99.5275,
    x2: 20.8045,
    y2: 99.5275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADD3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2395_11214",
    x1: 95.4787,
    y1: 98.0253,
    x2: 34.2016,
    y2: 98.0253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADD3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2395_11214",
    x1: 155.289,
    y1: 101.885,
    x2: 86.6736,
    y2: 101.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADD3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2395_11214",
    x1: 89.5244,
    y1: 102.156,
    x2: 28.2473,
    y2: 102.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADD3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2395_11214",
    x1: 98.1932,
    y1: 101.781,
    x2: 44.6216,
    y2: 101.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADD3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2395_11214",
    x1: 6.07784,
    y1: 101.781,
    x2: 59.6494,
    y2: 101.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADD3E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADD3E7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2395_11214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 97,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2395_11214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.5156,
    height: 20.2805,
    fill: "white",
    transform: "matrix(-1 0 0 1 51.3201 87.9864)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2395_11214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.1477,
    height: 20.2805,
    fill: "white",
    transform: "matrix(-1 0 0 1 96.3493 86.4841)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2395_11214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.5905,
    height: 21.7828,
    fill: "white",
    transform: "matrix(-1 0 0 1 156.264 89.4886)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2395_11214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.1477,
    height: 20.2805,
    fill: "white",
    transform: "matrix(-1 0 0 1 90.395 90.6154)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2395_11214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.3327,
    height: 20.2805,
    fill: "white",
    transform: "matrix(-1 0 0 1 98.9543 90.2398)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_2395_11214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.3327,
    height: 20.2805,
    fill: "white",
    transform: "translate(5.31673 90.2398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowManWeb);
export default __webpack_public_path__ + "static/media/snow-man-web.91c446b15496eb3479eb0bb0d1f3a124.svg";
export { ForwardRef as ReactComponent };